{
  "ui": {
    "loadFailed": "Não foi possível carregar os dados. {{message}}",
    "retry": "Tentar novamente"
  },
  "product": {
    "name": "Wundrlst"
  },
  "features": {
    "eyebrow": "Por que o Wundrlst",
    "sectionTitle": "Organização forte para um processo caótico",
    "sectionSubtitle": "Vistos, documentos, recursos salvos e orçamento em um só lugar — uma superfície calma para acompanhar o que importa.",
    "f1Title": "Requisitos de visto",
    "f1Desc": "Status de visto na hora para sua nacionalidade e destino. 500+ rotas em 30+ nacionalidades e 80+ destinos.",
    "f2Title": "Gestão de tarefas",
    "f2Desc": "Cada passo organizado em um só espaço — de documentos às datas da viagem.",
    "f3Title": "Extração de documentos",
    "f3Desc": "Envie o passaporte. Extraímos os dados automaticamente.",
    "f4Title": "Acompanhamento de orçamento",
    "f4Desc": "Acompanhe custos, defina limites e veja quanto sobrou.",
    "f5Title": "Assistente de IA",
    "f5Desc": "Pergunte o que quiser sobre sua rota. Respostas na hora.",
    "f6Title": "Vários idiomas",
    "f6Desc": "Disponível em inglês e português. Mais idiomas em breve."
  },
  "personas": {
    "title": "Para quem é o Wundrlst?",
    "subtitle": "De quem está planejando a primeira viagem a quem já está organizando a mudança definitiva.",
    "hoverLabel": "Para você",
    "p1Title": "Profissional em relocação",
    "p1Desc": "Está indo trabalhar em outro país e precisa organizar visto, documentos e moradia ao mesmo tempo.",
    "p2Title": "Estudante internacional",
    "p2Desc": "Vai estudar no exterior e precisa acompanhar carta de aceitação, visto de estudante e acomodação.",
    "p3Title": "Família em mudança",
    "p3Desc": "Mudança para toda a família — documentos de cada membro, escola para os filhos, novo lar.",
    "p4Title": "Nômade digital",
    "p4Desc": "Trabalha remotamente e quer estrutura para mudanças frequentes entre países.",
    "p5Title": "Viajante de longa duração",
    "p5Desc": "Planeja estadias longas e quer tarefas, documentos e orçamento organizados no mesmo workspace.",
    "p6Title": "Quem está explorando opções",
    "p6Desc": "Ainda pesquisando destinos e vistos — quer clareza antes de decidir."
  },
  "visa": {
    "unverifiedDisclaimer": "Esta informação foi gerada por IA e pode não refletir os requisitos mais recentes. Verifique sempre com a embaixada ou consulado oficial antes de solicitar.",
    "pendingDisclaimer": "Esta informação foi gerada por IA e pode não refletir os requisitos mais recentes. Verifique sempre com a embaixada ou consulado oficial antes de solicitar."
  },
  "taskCategories": {
    "visaApplication": "Pedido de Visto",
    "documentCollection": "Recolha de Documentos",
    "flightBooking": "Reserva de Voo",
    "accommodation": "Alojamento",
    "rentalCar": "Carro de Aluguer",
    "appointment": "Marcação",
    "bankAccount": "Conta Bancária",
    "registration": "Registo",
    "movingLogistics": "Logística de Mudança",
    "general": "Geral"
  },
  "errors": {
    "workspaceNoAccess": "Espaço não encontrado ou sem permissão de acesso.",
    "loadTasks": "Não foi possível carregar as tarefas.",
    "loadTasksWithDetail": "{{message}}",
    "loadDocuments": "Não foi possível carregar os documentos.",
    "required": "Este campo é obrigatório",
    "notFound": {
      "title": "Página não encontrada",
      "description": "Esta URL não corresponde a nenhuma tela do app. Confira o endereço ou volte ao painel.",
      "cta": "Ir ao painel"
    },
    "boundary": {
      "title": "Algo deu errado ao carregar esta seção.",
      "reload": "Recarregar página",
      "tryAgain": "Tentar de novo"
    }
  },
  "workspaces": {
    "duplicateName": "Você já tem um workspace com este nome. Escolha outro nome.",
    "duplicateNameDescription": "Cada viagem precisa de um nome único na sua conta.",
    "nameRequired": "Informe um nome para o workspace.",
    "destinationTbd": "A definir",
    "toast": {
      "loadFailed": "Não foi possível carregar os espaços de trabalho.",
      "taskStatsFailed": "Espaços carregados, mas as estatísticas de tarefas falharam: {{message}}",
      "itineraryStatsFailed": "Espaços carregados, mas os prazos do itinerário falharam: {{message}}",
      "budgetStatsFailed": "Espaços carregados, mas o orçamento não pôde ser lido: {{message}}",
      "created": "Espaço de trabalho criado.",
      "createdFromTemplate": "Espaço criado a partir do modelo.",
      "deleted": "Espaço excluído.",
      "statusDone": "Espaço marcado como concluído.",
      "statusUpdated": "Status atualizado.",
      "loginRequired": "É preciso entrar na conta.",
      "onlyOwnerDelete": "Só o dono pode excluir este workspace.",
      "onlyOwnerStatus": "Só o dono pode alterar o status.",
      "onlyOwnerMembers": "Só o dono pode adicionar membros.",
      "enterMemberUuid": "Informe o UUID do usuário.",
      "statusColumnMissing": "A coluna workspaces.status ainda não existe. Rode a migration no Supabase e recarregue o schema (Settings → API).",
      "memberAdded": "Membro adicionado.",
      "noPermission": "Sem permissão.",
      "memberLimit": "Limite de {{max}} membros por workspace (ajuste VITE_MAX_WORKSPACE_MEMBERS ou faça upgrade quando houver planos).",
      "memberRemoved": "Membro removido.",
      "templateCreateFailed": "Não foi possível criar o espaço a partir do modelo.",
      "membersTableMissing": "A tabela workspace_members ainda não existe. Rode as migrations e recarregue o schema.",
      "membersTableMissingShort": "A tabela workspace_members ainda não existe. Rode as migrations em supabase/migrations/ e recarregue o schema da API.",
      "alreadyOwner": "Você já é o dono deste workspace.",
      "missingCountries": "Selecione nacionalidade, país de partida e destino.",
      "visaTypeRequired": "Escolha um tipo de visto para esta rota."
    }
  },
  "nav": {
    "dashboard": "Painel",
    "workspaces": "Espaços de trabalho",
    "templates": "Jornadas",
    "resources": "Recursos",
    "visaExplorer": "Consulta de vistos",
    "settings": "Configurações",
    "signOut": "Sair",
    "blankWorkspace": "Espaço em branco",
    "fromTemplate": "Assistente guiado",
    "loading": "Carregando…"
  },
  "commandPalette": {
    "dialogTitle": "Paleta de comandos",
    "dialogDescription": "Busque navegação, espaços e ações rápidas",
    "searchPlaceholder": "Buscar…",
    "navigation": "Navegação",
    "quickActions": "Ações rápidas",
    "workspaces": "Workspaces",
    "help": "Ajuda",
    "empty": "Nenhum resultado encontrado.",
    "openShortcutHint": "Abrir paleta de comandos (⌘K ou Ctrl+K)",
    "navPanel": "Painel",
    "navTasks": "Tarefas",
    "navDocuments": "Documentos",
    "navBookings": "Reservas",
    "navPacking": "Malas",
    "navResources": "Recursos",
    "navSettings": "Configurações",
    "quickNewTask": "Nova tarefa",
    "quickNewBooking": "Nova reserva",
    "quickImportDoc": "Importar documento",
    "quickImportTask": "Importar tarefa",
    "helpDocs": "Documentação",
    "helpFeedback": "Enviar feedback",
    "adminNavigation": "Admin",
    "navAdminOverview": "Início do admin",
    "navAdminArea": "Admin"
  },
  "profileMenu": {
    "openMenu": "Menu da conta",
    "fallbackName": "Conta",
    "displaySection": "Exibição",
    "settingsSection": "Configurações",
    "planSection": "Plano",
    "planFree": "Gratuito",
    "planPro": "Pro",
    "upgrade": "Fazer upgrade",
    "supportSection": "Suporte",
    "sendFeedback": "Enviar feedback",
    "signOut": "Sair"
  },
  "dashboard": {
    "title": "Seus Planos",
    "emptyTitle": "Crie seu primeiro plano",
    "emptySubtitle": "Comece a planejar sua mudança, estudo ou viagem.",
    "lastModified": "Modificado há",
    "tasks": "Tarefas",
    "documents": "Documentos",
    "loadingWorkspaces": "Carregando seus espaços…",
    "workspaceCount_one": "{{count}} espaço de trabalho",
    "workspaceCount_other": "{{count}} espaços de trabalho",
    "newWorkspace": "Novo espaço de trabalho",
    "newWorkspaceDesc": "Um espaço por destino ou processo de mudança. Para uma lista pré-preenchida, use",
    "newWorkspaceDescProvisioned": "Vamos criar tarefas a partir dos requisitos de visto para passaporte × destino quando tivermos dados.",
    "name": "Nome",
    "destination": "Destino",
    "createWorkspace": "Criar espaço",
    "creating": "Criando…",
    "tryAgain": "Tentar novamente",
    "blankWorkspace": "Espaço em branco",
    "fromTemplate": "Assistente guiado",
    "workspaceCreateBlankDesc": "Comece vazio e adicione tarefas manualmente",
    "workspaceCreateWizardDesc": "Responda a algumas perguntas — montamos o seu workspace",
    "createFromTemplateCard": "Criar workspace com checklist de visto",
    "create": {
      "nationality": "Nacionalidade (passaporte)",
      "nationalityPlaceholder": "Selecione o país",
      "sameAsNationality": "País de partida igual à nacionalidade",
      "startingFrom": "Partindo de",
      "startingFromPlaceholder": "País de residência",
      "destinationPlaceholder": "Para onde você vai?",
      "tripType": "Tipo de viagem",
      "tripRelocation": "Mudança",
      "tripStudy": "Estudo",
      "tripTrip": "Viagem",
      "tripNomad": "Nômade digital",
      "tripExploring": "Explorando",
      "hasVisaQuestion": "Você já tem visto para esta viagem?",
      "hasVisaYes": "Sim",
      "hasVisaNo": "Não",
      "visaTypeLabel": "Tipo de visto",
      "noVisaRoute": "Ainda não temos esta rota na base de vistos — você ainda pode criar o workspace.",
      "visaTypeAuto": "Selecionado automaticamente: {{type}}",
      "workspaceNameOptional": "Nome do workspace (opcional)",
      "workspaceNamePlaceholder": "Ex.: Portugal — Visto de trabalho",
      "tripNameLabel": "Nome da viagem / workspace",
      "tripNameHint": "Opcional — sugerimos um nome a partir do destino se deixar em branco.",
      "reviewNameUnset": "Automático pelo destino",
      "reviewBudgetUnset": "Não informado",
      "countryInvalid": "Selecione um país válido"
    },
    "createWorkspaceStep": {
      "navAria": "Etapas de criação do workspace",
      "shellSubtitle": "Configure seu workspace de viagem passo a passo.",
      "destination": "Destino",
      "destinationTitle": "Passaporte, rota e tipo de viagem",
      "tripDetails": "Detalhes da viagem",
      "tripDetailsTitle": "Nome e orçamento",
      "visaTravel": "Visto e viagem",
      "visaTravelTitle": "Visto para esta rota",
      "review": "Revisão",
      "reviewTitle": "Confirmar e criar"
    },
    "overview": {
      "stats": {
        "tasks": "Tarefas",
        "documents": "Documentos",
        "ariaLabel": "Indicadores do workspace"
      }
    },
    "dottedMap": {
      "title": "Destinos",
      "description": "Lugares desta conta (a partir dos seus planos)"
    }
  },
  "workspaceCard": {
    "noDestination": "Sem destino definido",
    "overdue": "atrasada",
    "overdue_other": "atrasadas",
    "tasks": "Tarefas",
    "shared": "Compartilhado",
    "open": "Abrir",
    "documents": "Documentos",
    "settings": "Configurações",
    "delete": "Excluir",
    "deleteTitle": "Excluir \"{{name}}\"?",
    "deleteDesc": "Esta ação não pode ser desfeita. O espaço e todas as suas tarefas, documentos e reservas serão excluídos permanentemente.",
    "cancel": "Cancelar",
    "deleting": "Excluindo…",
    "justNow": "Agora mesmo",
    "minutesAgo": "{{count}}min atrás",
    "hoursAgo": "{{count}}h atrás",
    "yesterday": "Ontem",
    "daysAgo": "{{count}} dias atrás",
    "weekAgo": "{{count}} semana atrás",
    "weeksAgo": "{{count}} semanas atrás",
    "monthAgo": "{{count}} mês atrás",
    "monthsAgo": "{{count}} meses atrás",
    "budgetUsed": "{{pct}}% do orçamento usado",
    "openWorkspaceAria": "Abrir workspace {{name}}",
    "optionsAria": "Opções para {{name}}"
  },
  "onboarding": {
    "cancel": "Sair",
    "wizardHeading": "Comece a usar o Wundrlst",
    "stepOf": "Passo {{current}} de {{total}}",
    "step1Title": "Que tipo de viagem você está planejando?",
    "step1Subtitle": "Isso nos ajuda a mostrar as opções de visto e tarefas certas.",
    "step1Of2": "Passo 1 de 2",
    "step2Of2": "Passo 2 de 2",
    "step2TripTitle": "Passaporte, residência e destino",
    "step2TripSubtitle": "Usamos isso para sugerir vistos, documentos e tarefas. Você pode editar tudo depois.",
    "step2aTitle": "De onde para onde você vai?",
    "step2aSubtitle": "Cruzamos seu passaporte e o destino com os tipos de visto no nosso banco.",
    "step2aWizardTitle": "De onde → para onde?",
    "step2aWizardSubtitle": "País do passaporte e destino",
    "step2RouteVisaWizardTitle": "Rota e status do visto",
    "step2RouteVisaWizardSubtitle": "País do passaporte, destino e situação do visto",
    "step2aVisaPreviewStudy": "{{origin}} → {{destination}}: visto de estudante necessário ✓ ({{count}} tipos no banco)",
    "step2aVisaPreviewTrip": "{{origin}} → {{destination}}: visto de visita/turismo necessário ✓ ({{count}} tipos no banco)",
    "step2aVisaPreviewRelocation": "{{origin}} → {{destination}}: visto de trabalho ou residência necessário ✓ ({{count}} tipos no banco)",
    "step2aVisaPreviewFamily": "{{origin}} → {{destination}}: visto familiar necessário ✓ ({{count}} tipos no banco)",
    "step2aVisaPreviewExploring": "{{origin}} → {{destination}}: pode ser necessário um visto ✓ ({{count}} tipos no banco)",
    "step2aVisaPreviewDigitalNomad": "{{origin}} → {{destination}}: visto de nômade digital necessário ✓ ({{count}} tipos no banco)",
    "step2aNoTypesHint": "{{origin}} → {{destination}}: ainda não temos tipos de visto para essa rota — você pode continuar; completaremos os detalhes do visto quando possível.",
    "noRouteData": "Ainda não temos dados de visto para esta rota.",
    "notifyMe": "Notificar-me quando estiver disponível",
    "notifySuccess": "Você está na lista — enviaremos um e-mail quando estiver pronto.",
    "notifyEmailPlaceholder": "seu@email.com",
    "notifySubmit": "Enviar",
    "step2bTitle": "Status do visto",
    "step2bSubtitle": "Diga se você já tem visto, vai solicitar ou entra sem visto para visitas curtas.",
    "step2bWizardTitle": "Status do visto",
    "step2bWizardSubtitle": "Viagem para {{destination}} — o que se aplica a você?",
    "step2bHaveValid": "Já tenho um visto válido para esta viagem",
    "step2bNeedApply": "Preciso solicitar um visto",
    "step2bHaveValidWithPreview": "Já tenho um visto {{visa}} válido",
    "step2bNeedApplyWithPreview": "Preciso solicitar um visto {{visa}}",
    "step2bVisaProductShortStudy": "de estudante",
    "step2bVisaProductShortTrip": "de visita / viagem",
    "step2bVisaProductShortRelocation": "de trabalho ou residência",
    "step2bVisaProductShortFamily": "familiar",
    "step2bVisaProductShortDigitalNomad": "de nômade digital",
    "step2bVisaProductShortGeneric": "adequado",
    "step2bVisaFree": "Sem visto ou visita curta (sem visto para o meu plano)",
    "step2bSubtypeLabel": "Tipo de visto",
    "step2bSingleTypeHint": "A rota tem um tipo no banco: {{type}} — usaremos para o seu workspace.",
    "step2cTitle": "Orçamento da viagem",
    "step2cSubtitle": "Ajuste o valor total estimado. A moeda segue o país do passaporte.",
    "step2cWizardTitle": "Orçamento da viagem",
    "step2cWizardSubtitle": "Estime o custo total",
    "step2cAmountLabel": "Orçamento estimado",
    "step2cCurrencyFromNationality": "Moeda conforme o país do passaporte",
    "step2cWorkspaceCurrencyHint": "Isso define a moeda apenas para este workspace",
    "step2cCurrencySearch": "Buscar moeda…",
    "step2cRangeHint": "Faixa {{min}}–{{max}} (números inteiros na sua moeda).",
    "step2cUnlimitedHint": "Digite qualquer valor acima ou use o controle deslizante (até {{sliderMax}}) como guia — não há teto de orçamento.",
    "tripPassportOrigin": "País do passaporte (nacionalidade)",
    "useCurrentLocation": "Usar localização atual",
    "locationDetecting": "Detectando…",
    "locationDenied": "Acesso à localização foi negado.",
    "locationFailed": "Não foi possível detectar o país pela sua localização.",
    "locationUnavailable": "Localização não disponível neste navegador.",
    "tripResidence": "País onde você mora agora",
    "tripDestination": "País de destino",
    "tripContextVisaHaveQuestion": "Você já tem um visto para {{destination}}?",
    "tripContextVisaHaveYes": "Sim, já tenho",
    "tripContextVisaHaveNo": "Não, preciso solicitar",
    "tripContextWhichVisaHave": "Qual tipo de visto você tem?",
    "tripContextWhichVisaApplying": "Para qual tipo de visto você vai solicitar?",
    "budgetLabel": "Orçamento total estimado",
    "budgetOptional": "(opcional)",
    "budgetAmountPlaceholder": "0",
    "visaProceedHint": "Quando estiver pronto, toque em Continuar — em seguida criamos seu workspace.",
    "step2Title": "Qual é sua nacionalidade?",
    "step2Subtitle": "Isso nos ajuda a identificar os vistos disponíveis para você.",
    "step3Title": "De onde você está se mudando?",
    "step3Subtitle": "Seu país de residência atual.",
    "sameAsNationality": "Mesmo que minha nacionalidade",
    "step4Title": "Para onde você quer ir?",
    "step4Subtitle": "Escolha seu destino principal.",
    "step5Title": "Você já tem visto para {{destination}}?",
    "step5Subtitle": "Diga-nos se você já tem um visto válido.",
    "hasVisa": "Sim, já tenho visto",
    "noVisa": "Não, ainda não tenho",
    "whichVisa": "Qual visto você tem?",
    "visaSkipNote": "✓ Não mostraremos tarefas relacionadas ao visto.",
    "loadingVisaTypes": "Buscando tipos de visto…",
    "loadingVisaData": "Carregando dados de visto…",
    "visaApiError": "Não foi possível carregar os requisitos de visto. Tente novamente.",
    "retryVisa": "Tentar novamente",
    "visaFreeMessage": "Com passaporte emitido em {{passportCountry}}, normalmente você não precisa de visto para visitas curtas a {{destination}} (conforme a fonte de dados).",
    "visaFreeConflictIntro": "Você selecionou {{visaType}} para {{passportCountry}} → {{destination}}. A informação abaixo costuma valer para visitas curtas / turismo na fonte de dados — não substitui autorização para trabalho, estudo longo ou residência.",
    "visaFreeRelocationGoalHint": "Você indicou estadia longa ou mudança. Regras de visita curta podem não se aplicar — escolha o tipo de visto adequado e confirme com a autoridade oficial.",
    "visaOnArrivalMessage": "Com passaporte emitido em {{passportCountry}}, você pode ser elegível a visto na chegada em {{destination}}. Confirme elegibilidade, taxas e permanência máxima com a embaixada ou fonte oficial.",
    "visaOnArrivalConflictIntro": "Você selecionou {{visaType}}. Visto na chegada, quando existe, costuma ter limites de finalidade e tempo — confirme se cobre seu plano para {{destination}} antes de viajar.",
    "visaStatusHint": "Para passaporte de {{passportCountry}} com destino {{destination}}, a fonte indica: {{status}}.",
    "visaBannerVisaTypeLine": "Tipo de visto selecionado: {{visaType}}.",
    "visaRequirementsVerifyNotice": "As regras para quem viaja de {{passportCountry}} para {{destination}} mudam com frequência. Sempre confirme com a autoridade oficial antes de viajar ou solicitar visto.",
    "visaRequirementsVerifyNoticeWithType": "As regras para quem viaja de {{passportCountry}} para {{destination}}, inclusive para {{visaType}}, mudam com frequência. Sempre confirme com a autoridade oficial antes de viajar ou solicitar visto.",
    "visaTypeLabels": {
      "visitor": "Turismo / visita",
      "tourist": "Turismo",
      "work": "Trabalho ou visto nômade digital",
      "student": "Estudos",
      "business": "Negócios",
      "relocation": "Residência / mudança"
    },
    "whichVisaApply": "Qual visto você pretende solicitar?",
    "visaDataSource": "Dados: {{source}}",
    "visaLastUpdated": "Última atualização: {{date}}",
    "visaSourceCache": "cache (válida até 7 dias)",
    "visaSourceLive": "API em tempo real (nickypangers / Travel Buddy em produção)",
    "visaSourceCacheStale": "cache (API indisponível; dados podem estar desatualizados)",
    "visaSourceDev": "modo demonstração",
    "visaSourceMetadata": "referência interna de visto",
    "noVisaTypes": "Nenhum visto encontrado para esta combinação.",
    "selectVisaStatus": "Você já tem visto?",
    "selectVisaType": "Selecione o tipo de visto",
    "loadingPage": "Carregando…",
    "defaultWorkspaceName": {
      "study": "Meu intercâmbio",
      "family": "Mudança em família",
      "trip": "Minha viagem",
      "exploring": "Meu primeiro workspace",
      "relocation": "Meu plano de mudança"
    },
    "step6Title": "Quando você pretende viajar?",
    "step6Subtitle": "Isso nos ajuda a priorizar suas tarefas.",
    "timeline3m": "Nos próximos 3 meses",
    "timeline3mDesc": "Você precisa agir agora — priorizamos tarefas urgentes.",
    "timeline3to6m": "Entre 3 e 6 meses",
    "timeline3to6mDesc": "Bom ritmo para preparar documentos e pesquisar opções.",
    "timeline6mplus": "Mais de 6 meses",
    "timeline6mplusDesc": "Há tempo para planejar com calma.",
    "timelineUnknown": "Ainda não sei",
    "timelineUnknownDesc": "Sem pressa — organize suas ideias primeiro.",
    "step7Title": "Quem está viajando?",
    "step7Subtitle": "Adaptamos o plano de acordo.",
    "whoSolo": "Só eu",
    "whoSoloDesc": "Um plano focado na sua jornada individual.",
    "whoCouple": "Eu e parceiro(a)",
    "whoCoupleDesc": "Leve em conta duas pessoas e logística conjunta.",
    "whoFamily": "Família",
    "whoFamilyDesc": "Inclui crianças, escola, saúde e mais.",
    "termsLabel": "Eu aceito os",
    "termsLink": "Termos e Condições",
    "privacyLink": "Política de Privacidade",
    "andThe": "e a",
    "mustAcceptTerms": "Você deve aceitar os termos para continuar.",
    "continue": "Continuar",
    "skip": "Pular",
    "back": "Voltar",
    "clearDestination": "Limpar destino",
    "completeOnboarding": "Completar onboarding",
    "creatingPlan": "Criando…",
    "chooseReadyPlan": "Escolha um plano pronto (você pode editar tudo depois)",
    "startBlank": "Começar em branco",
    "country": "País",
    "city": "Cidade (opcional)",
    "searchCountry": "Buscar país…",
    "searchCurrency": "Buscar moeda…",
    "fxLoadingCurrencies": "Carregando lista de moedas…",
    "nationality": "Nacionalidade",
    "location": "País de residência atual",
    "destination": "Destino",
    "countryPlaceholder": "Ex.: Portugal, Canadá, Espanha…",
    "citySearchPlaceholder": "Buscar cidade…",
    "cityManualPlaceholder": "Ex.: Lisboa, Toronto…",
    "chooseCityFirst": "Escolha um país para ver cidades sugeridas.",
    "cityListAvailable": "Lista de cidades para {{country}} — busque ou toque para selecionar. Você também pode digitar outro nome.",
    "cityListUnavailable": "Não temos lista pronta para este nome de país — escreva a cidade à mão.",
    "loadingVisa": "Carregando informações sobre vistos…",
    "updatingVisa": "Atualizando contexto de visto…",
    "commonVisas": "Vistos comuns (orientação)",
    "visaForBrazilians": "Para brasileiros indo para {{country}} como {{goal}}",
    "frequentVisas": ", vistos ou trâmites frequentemente citados: {{visas}}.",
    "noVisaList": " — não há lista de tipos de visto nesta base para esta combinação.",
    "estimatedTimeline": "Timeline estimado:",
    "confirmWith": "Confirme com:",
    "officialSite": "site oficial",
    "visaDisclaimer": "Esta informação é orientacional. Confirme com fontes oficiais ou um consultor de imigração.",
    "visaContextTitle": "Vistos no seu cenário",
    "visaTypesListed": "Tipos citados na base: {{visas}}.",
    "estimatedDeadline": "Prazo estimado:",
    "noVisaEntryFound": "Não encontramos uma entrada de visto para este país e objetivo na base — você ainda pode continuar e adicionar tarefas manualmente.",
    "goalRelocation": "Mudança",
    "goalRelocationDesc": "Morar no exterior por trabalho, família ou longo prazo.",
    "goalStudy": "Estudar no exterior",
    "goalStudyDesc": "Visto de estudante, documentos e preparação para chegada.",
    "goalFamily": "Mudança em família",
    "goalFamilyDesc": "Um plano para todos.",
    "goalTrip": "Férias",
    "goalTripDesc": "Reservas, checklists e o que esperar na fronteira.",
    "goalExploring": "Só explorando",
    "goalExploringDesc": "Organize ideias antes de decidir.",
    "goalDigitalNomad": "Nômade digital",
    "goalDigitalNomadDesc": "Trabalho remoto no exterior com o visto e setup certos.",
    "failedToSave": "Failed to save progress — try again",
    "mustSignIn": "You must be signed in.",
    "workspaceCreated": "Workspace created.",
    "provisioningWorkspaceRoute": "Preparando seu workspace {{origin}} → {{dest}}…",
    "failedToComplete": "Não foi possível concluir o onboarding.",
    "failedToSkip": "Failed to skip onboarding — try again",
    "profileNotSaved": "Workspace pronto, mas o perfil não foi salvo: {error}",
    "schemaHelp": "No Supabase: SQL → cole o conteúdo de supabase/apply_profiles_onboarding_columns.sql → Run. Depois: Settings → API → Reload schema."
  },
  "workspaceWizard": {
    "brand": "Wundrlst",
    "wizardHeading": "Criar um novo workspace",
    "pageTitle": "Novo workspace",
    "cancel": "Voltar aos espaços",
    "stepOf": "Passo {{current}} de {{total}}",
    "backShort": "← Voltar",
    "step7Title": "Para quem é este plano?",
    "step7Subtitle": "Personalizamos tarefas e dicas. Você pode mudar depois.",
    "createWorkspace": "Criar workspace",
    "creatingWorkspace": "Criando workspace…",
    "created": "Workspace criado.",
    "createFailed": "Não foi possível criar o workspace.",
    "createBlankNow": "Criar em branco",
    "createWorkspaceHint": "Vamos criar o workspace e adicionar tarefas de visto quando tivermos dados para a sua rota."
  },
  "workspace": {
    "breadcrumbHome": "Painel",
    "tasksProgress": "{{done}}/{{total}} tarefas",
    "taskProgressComplete": "{{done}} de {{total}} tarefas concluídas",
    "noDestination": "Sem destino",
    "routeInProgress": "Estamos a construir esta rota",
    "routeInProgressBody": "O guia passo a passo de visto para {{nat}} → {{dest}} chega em breve. As tarefas abaixo são um ponto de partida — recomendamos também verificar o site oficial da embaixada.",
    "checkEmbassy": "Ver embaixada →",
    "resourcesSuggested": "Recursos sugeridos",
    "editWorkspaceName": "Editar nome do workspace",
    "saveWorkspaceName": "Salvar",
    "cancelRename": "Cancelar",
    "workspaceNameEmpty": "O nome do workspace não pode ficar vazio.",
    "workspaceRenameFailed": "Não foi possível atualizar o nome do workspace.",
    "workspaceRenamed": "Nome do workspace atualizado.",
    "error": {
      "message": "O workspace foi criado, mas algumas tarefas da checklist não puderam ser geradas automaticamente.",
      "viewAnyway": "Ver workspace",
      "retry": "Ir para Tarefas"
    },
    "headerAddTask": "Adicionar nova tarefa",
    "header": {
      "shareButton": "Compartilhar workspace",
      "progress": "{{done}} / {{total}} tarefas"
    },
    "chatbot": {
      "globalDefaultsNotice": "Os padrões globais de IA ficam em Conta → IA. Estas configurações do workspace continuam substituindo os padrões globais por enquanto.",
      "openGlobalSettings": "Abrir configurações globais de IA"
    },
    "create": {
      "step": "Passo {{current}} de {{total}}",
      "back": "← Voltar",
      "invalidCountry": "Esse país não está na lista. Escolha um país válido na lista.",
      "provisionCreating": "Criando workspace…",
      "provisionSeedingVisa": "Preparando tarefas de visto…",
      "provisionDocuments": "Preparando documentos…",
      "provisionAlmostReady": "Quase pronto…"
    },
    "overview": {
      "dismissBanner": "Dispensar banner de boas-vindas"
    },
    "stickyBar": {
      "tasks": "{{done}} / {{total}} tarefas",
      "budget": "{{pct}}% do orçamento usado",
      "days": "{{count}} dias até a viagem"
    },
    "travelDate": {
      "widgetTitle": "Data da viagem",
      "widgetDescription": "Quando o workspace tiver uma data de viagem, aparecerão aqui contagem e contexto de cronograma. (Ainda não disponível.)"
    }
  },
  "workspaceSettings": {
    "pageTitle": "Configurações do workspace",
    "pageTitleWithName": "{{name}} — configurações",
    "lead": "Campos personalizados e colaboradores. Convide por e-mail com link seguro.",
    "navLabel": "Seções das configurações do workspace",
    "navGeneral": "Geral",
    "navChatbot": "Assistente de IA",
    "loading": "Carregando configurações…",
    "customFields": "Campos personalizados nas tarefas",
    "customFieldsDescription": "Defina chaves reutilizáveis nos formulários de tarefas e na tabela.",
    "onlyOwnerCanEdit": "Apenas o dono pode editar esta lista.",
    "loadingFields": "Carregando…",
    "noExtraFields": "Nenhum campo extra ainda.",
    "newField": "Novo campo",
    "inviteCollaborator": "Convidar colaborador(a)",
    "inviteDesc": "Envie um convite por e-mail. Compartilhe o link com a pessoa — ela pode criar uma conta se ainda não tiver.",
    "email": "E-mail",
    "emailPlaceholder": "nome@exemplo.com",
    "inviteButton": "Convidar",
    "noCollaborators": "Ainda não há colaboradores.",
    "collaborator": "Colaborador(a)",
    "remove": "Remover",
    "fieldLabel": "Rótulo",
    "fieldLabelExample": "Ex.: Número do processo",
    "fieldType": "Tipo",
    "fieldTypeText": "Texto",
    "fieldTypeNumber": "Número",
    "fieldTypeDate": "Data",
    "fieldTypeBoolean": "Sim / Não",
    "fieldKey": "Chave técnica é gerada a partir do rótulo.",
    "cancel": "Cancelar",
    "save": "Salvar",
    "noAccount": "Não encontramos conta com esse e-mail. Peça para a pessoa se cadastrar primeiro.",
    "inviteFailed": "Não foi possível convidar o colaborador. Tente novamente.",
    "alreadyCollaborator": "Esta pessoa já é colaboradora deste workspace.",
    "inviteSuccess": "Colaborador(a) adicionado(a).",
    "inviteSentTitle": "Link de convite criado",
    "inviteSentDescription": "Envie este link para a pessoa:\n{{link}}",
    "invitePendingExists": "Já existe um convite pendente para este e-mail.",
    "invitesUnavailable": "Convites de colaboradores ainda não estão disponíveis. Você ainda pode adicionar membros por ID de usuário quando essa opção estiver ativa.",
    "inviteSelf": "Você não pode convidar o seu próprio e-mail.",
    "existingAccess": "Pessoas com acesso",
    "memberBadge": "membro"
  },
  "acceptInvite": {
    "invalidLink": "Link de convite inválido.",
    "headlineGuest": "Você foi convidado para colaborar no Wundrlst",
    "guestHint": "Crie uma conta ou entre com o mesmo e-mail para o qual o convite foi enviado. Depois você poderá aceitar o convite.",
    "createAccount": "Criar conta",
    "signIn": "Já tenho conta, entrar",
    "acceptButton": "Aceitar convite",
    "expiredOrInvalid": "Convite expirado ou inválido.",
    "backHome": "Voltar ao início",
    "backDashboard": "Ir ao painel",
    "invitedBy": "Convidado(a) por",
    "copyright": "© {{year}} Wundrlst",
    "footerPrivacy": "Privacidade",
    "footerTerms": "Termos"
  },
  "admin": {
    "overview": "Saúde",
    "routes": {
      "title": "Rotas",
      "funnelPending": "Aguardando revisão",
      "funnelLive": "Ao vivo",
      "funnelInReview": "Em revisão",
      "funnelVerified": "Verificado",
      "funnelOther": "Outro",
      "toolbarStatusFlagged": "Sinalizadas para revisão",
      "statsNeedsReview": "Precisam revisão",
      "toolbarLocalePlaceholder": "Idioma do conteúdo",
      "toolbarLocaleSearchPlaceholder": "Buscar idioma…",
      "toolbarLocaleOptionAll": "Todos os idiomas",
      "toolbarLocaleOptionEnglish": "Inglês",
      "toolbarLocaleOptionPortugueseBrazil": "Português (Brasil)",
      "statsVerifiedNotLive": "Verificadas, não publicadas",
      "statsVerifiedNotLiveHint": "Verificadas mas ainda não publicadas para utilizadores — trate esta fila quando possível.",
      "toolbarStatusVerifiedNotLive": "Verificadas, não ao vivo"
    },
    "shellLabel": "Admin",
    "quality": {
      "sources": "{{count}} fontes",
      "missing": "{{count}} em falta",
      "none": "Sem fontes ligadas"
    },
    "enrichment": {
      "revert": "Reverter",
      "revertConfirm": "Restaurar os passos do processo salvos antes do último enriquecimento? A reversão no banco ainda não está ligada — isto apenas registra a intenção.",
      "revertQueued": "Reversão enfileirada. O suporte no backend aplicará a versão anterior."
    },
    "settings": {
      "nav": "Configurações",
      "pipeline": {
        "title": "Config do pipeline",
        "description": "Define quais modelos de IA enriquecem rotas de visto nas Edge Functions. Vale na próxima execução — sem novo deploy.",
        "primary": "Modelo principal (enriquecimento completo)",
        "validator": "Modelo validador (checagem de status de visto)",
        "validatorEnabled": "Rodar validador após sucesso do principal",
        "fallbackOrder": "Ordem de fallback",
        "fallbackOrderHint": "Se o modelo principal falhar, os outros são tentados nesta ordem.",
        "save": "Salvar alterações",
        "saving": "Salvando…",
        "reload": "Recarregar do banco",
        "loadFailed": "Não foi possível carregar a config do pipeline. {{message}}",
        "saveSuccess": "Config do pipeline salva.",
        "saveFailed": "Não foi possível salvar. {{message}}",
        "loading": "Carregando config do pipeline…"
      }
    },
    "openAdminPanel": "Painel admin",
    "sidebarAreaLabel": "Administração",
    "verify": {
      "drawerTitle": "Revisão de verificação",
      "keyFacts": "Dados-chave",
      "processSteps": "Passos do processo",
      "sources": "Fontes",
      "totalCost": "Custo total",
      "totalTime": "Tempo total",
      "markVerified": "Marcar como verificada",
      "skipRoute": "Pular",
      "flagIssue": "Sinalizar problema",
      "flagNote": "O que está errado com esta rota?",
      "flagSubmit": "Enviar sinalização",
      "flagSuccess": "Rota sinalizada para re-enriquecimento",
      "verifySuccess": "Rota verificada",
      "queueProgress": "{{verified}} verificadas nesta sessão | {{remaining}} restantes",
      "queueEmpty": "Não há rotas pendentes na fila de revisão.",
      "reviewQueue": "Revisar fila ({{count}})"
    },
    "visaMetadata": {
      "markVerifiedToolbar": "Marcar como verificadas",
      "markVerifiedLoading": "A verificar linhas…",
      "bulkActionDisabledAllFilteredHint": "Para todas as linhas dos filtros, use Marcar como verificadas, Sinalizar ou Re-enriquecer na barra de ferramentas.",
      "enrichSelectedDisabledAllFilteredHint": "Selecione linhas individuais para enriquecer. O enriquecimento em massa de todos os filtros não é suportado para não sobrecarregar o pipeline de enriquecimento.",
      "bulkDeleteDisabledAllFiltered": "Eliminação em massa aplica-se só à página atual. Ajuste os filtros ou mude de página.",
      "bulkDeleteUnsupportedAllFiltered": "Não é possível eliminar todas as linhas filtradas a partir deste menu. Reduza a seleção ou mude os filtros.",
      "markVerifiedSuccess": "{{count}} linhas marcadas como verificadas",
      "markVerifiedFailed": "Falha ao verificar linhas: {{message}}",
      "exportSelected": "Exportar selecionadas",
      "exportSuccess": "{{count}} rotas exportadas",
      "exportEmpty": "Nada para exportar.",
      "exportFailed": "Falha na exportação: {{message}}",
      "nav": "Rotas",
      "verifyAction": "Verificar",
      "verifySuccess": "Rota verificada",
      "verifyRowFailed": "Não foi possível aprovar a rota: {{message}}",
      "columnConfidenceScore": "Confiança",
      "confidenceTooltip": "Confiança da IA na qualidade dos dados desta rota. Abaixo de 0,70 pode valer um re-enriquecimento.",
      "confidenceTooltipAria": "Sobre as pontuações de confiança da IA",
      "viewNeedsReview": "Precisam revisão",
      "approveRoute": "Aprovar",
      "needsReviewFocusButton": "Precisam revisão ({{count}})",
      "statsNeedsReviewHint": "Rotas à espera de verificação ou sinalizadas para acompanhamento (combinadas).",
      "quickReEnrichStarting": "Re-enriquecimento…",
      "quickReEnrichOk": "{{count}} rota enfileirada para re-enriquecimento (~ {{estimate}})",
      "flagForReviewSingleOk": "Rota sinalizada para revisão.",
      "flagForReviewSingleNoOp": "Nenhuma alteração aplicada.",
      "verificationFilterLabel": "Verificação",
      "verificationAll": "Todas",
      "verificationUnverified": "Não verificada",
      "verificationPendingReview": "Em revisão",
      "verificationVerified": "Verificada",
      "enrichmentPipelineLegend": "Pipeline de enriquecimento",
      "columnsToggle": "Colunas",
      "columnsToggleMenu": "Colunas visíveis",
      "columnEnrichmentStatus": "Estado de enriquecimento",
      "columnVerificationStatus": "Estado de verificação",
      "columnFlagForReview": "Sinalizada",
      "columnFlagForReviewColumn": "Sinalizada para revisão",
      "flagForReviewBadge": "Sinalizada",
      "columnContentLocale": "Idioma",
      "columnCreatedAt": "Criada em",
      "columnUpdatedAt": "Atualizada em",
      "statusColumnHelpAria": "Significado dos estados de enriquecimento",
      "manualOverrideHint": "Sobrescrita de admin ativa",
      "dryRunTitle": "Simulação (dry-run)",
      "dryRunDescription": "Executa o enriquecimento sem gravar alterações na base de dados.",
      "flagForReviewButton": "Sinalizar para revisão",
      "flagForReviewLoading": "Sinalizando rotas para revisão…",
      "flagForReviewSuccess": "{{count}} rotas sinalizadas para revisão",
      "flagForReviewFailed": "Falha ao sinalizar rotas: {{message}}",
      "reEnrichEstimate": "{{count}} rotas marcadas para re-enriquecimento. Tempo estimado: {{estimate}}.\n\nVolte mais tarde ou execute 'npm run visa:enrich-pending' para iniciar.",
      "dryRun": {
        "showRawJson": "Mostrar JSON bruto",
        "hideRawJson": "Ocultar JSON bruto",
        "stepsFoundChip": "{{count}} etapas encontradas",
        "documentsRequiredChip": "{{count}} documentos obrigatórios",
        "estimatedCostChip": "{{cost}} custo estimado USD"
      },
      "status": {
        "pending": {
          "tooltip": "Rota existe mas ainda não foi enriquecida pela IA"
        },
        "enriching": {
          "tooltip": "Enriquecimento por IA em execução (Gemini 2.5)"
        },
        "approved": {
          "tooltip": "Revista e aprovada pelo admin, ainda não visível para utilizadores"
        },
        "live": {
          "tooltip": "Ativa — utilizadores veem esta rota em novos workspaces"
        }
      },
      "pushLive": {
        "dryRunRecommendedTitle": "Simulação recomendada",
        "dryRunRecommendedBody": "Ainda não executou uma simulação para esta rota. Pré-visualize as alterações primeiro.",
        "dryRunReadyTitle": "Simulação concluída",
        "dryRunReadyBody": "Simulação concluída. Pronto para ficar live.",
        "runDryRun": "Executar simulação"
      }
    },
    "visaMetadataReview": {
      "nav": "Fila de revisão",
      "pageTitle": "Fila de revisão",
      "subtitle": "Rotas aguardando verificação — menor confiança primeiro.",
      "loading": "Carregando fila de revisão…",
      "loadFailed": "Não foi possível carregar a fila de revisão. {{message}}",
      "summaryTotal": "{{count}} na fila",
      "summaryHighConfidence": "{{count}} com confiança ≥ 0,85",
      "summaryDisagreements": "{{count}} com notas de sincronização",
      "emptyTitle": "Fila de revisão vazia",
      "emptyDescription": "Quando o enriquecimento terminar com revisão pendente, as rotas aparecem aqui.",
      "openRoute": "Abrir rota",
      "sourceUnknown": "fonte desconhecida",
      "confidenceLabel": "Confiança {{value}}",
      "processStepsToggle": "Passos do processo ({{count}} títulos)",
      "noStepTitles": "Nenhum título de etapa no enriquecimento salvo.",
      "requiredDocuments": "Documentos obrigatórios",
      "noDocuments": "Nenhum documento listado.",
      "approve": "Aprovar",
      "reEnrich": "Re-enriquecer",
      "approveSuccess": "Rota aprovada e publicada (live).",
      "approveFailed": "Não foi possível aprovar a rota. {{message}}",
      "approveLiveGateDbFix": "Aprovação bloqueada na base de dados: o trigger antigo repõe a verificação ao ficar live. Aplique as migrações pendentes do Supabase (ex.: supabase db push) ou execute o SQL em supabase/migrations/20260506210000_reapply_visa_metadata_on_enrich_noop.sql no SQL Editor do Supabase.",
      "reEnrichSuccess": "Rota reposta para re-enriquecimento.",
      "reEnrichFailed": "Não foi possível repor a rota. {{message}}",
      "filterNationality": "Nacionalidade",
      "filterAllNationalities": "Todas as nacionalidades",
      "filterConfidence": "Confiança",
      "confidenceAll": "Todas as faixas",
      "confidenceHigh": "≥ 0,85",
      "confidenceMid": "0,50 – 0,84",
      "confidenceLow": "< 0,50",
      "filterSyncNote": "Nota de sync",
      "syncNoteAll": "Qualquer",
      "syncNoteYes": "Com nota",
      "syncNoteNo": "Sem nota",
      "selectAllFiltered": "Selecionar todos que batem com os filtros ({{count}})",
      "filteredCount": "{{count}} rotas correspondem aos filtros atuais.",
      "filterEmptyTitle": "Nenhuma rota com estes filtros",
      "filterEmptyDescription": "Ajuste os filtros ou limpe a nacionalidade para ver a fila novamente.",
      "clearFilters": "Limpar filtros",
      "batchToolbarLabel": "Ações em lote nas rotas selecionadas",
      "selectedCount": "{{count}} selecionadas",
      "batchApprove": "Aprovar selecionadas ({{count}})",
      "batchReenrich": "Re-enriquecer selecionadas ({{count}})",
      "batchApproveProgress": "Aprovando… {{current}} / {{total}}",
      "batchReenrichProgress": "Repondo… {{current}} / {{total}}",
      "batchApproveSummary": "Aprovadas {{ok}} rotas. {{failed}} falharam.",
      "batchReenrichSummary": "{{ok}} rotas repostas para re-enriquecimento. {{failed}} falharam.",
      "batchApproveFailed": "Aprovação em lote falhou. {{message}}",
      "batchReenrichFailed": "Re-enriquecimento em lote falhou. {{message}}",
      "selectPageAria": "Selecionar todas as linhas desta página",
      "selectRowAria": "Selecionar rota {{route}}",
      "colRoute": "Rota",
      "colConfidence": "Confiança",
      "colSync": "Nota de sync",
      "colActions": "Ações",
      "pageStatus": "Página {{page}} de {{pages}} · {{showing}} de {{total}} rotas",
      "prevPage": "Anterior",
      "nextPage": "Seguinte"
    },
    "routeDetail": {
      "routeSaved": "Rota salva",
      "unsavedChanges": "Alterações não salvas",
      "hasOverrides": "Com overrides",
      "loading": "Carregando rota…",
      "requirementNote": "Nota nos requisitos",
      "goalTypeField": "Objetivo",
      "contentLocaleField": "Idioma do conteúdo",
      "requiredDocsSection": "Documentos obrigatórios",
      "addDocument": "Adicionar documento",
      "addBullet": "Adicionar itens",
      "bulletPlaceholder": "Um item por linha",
      "titlePt": "Título (pt-BR)",
      "descriptionPt": "Descrição (pt-BR)",
      "readMode": "Modo leitura",
      "editMode": "Editar",
      "backToTable": "Voltar para a tabela",
      "notFound": "Rota não encontrada.",
      "adminNotes": "Notas do admin",
      "overrideActive": "Override ativo",
      "noOverride": "Sem override",
      "showingOverride": "Mostrando override do admin",
      "overrideSaved": "Override salvo — usuários verão isso no lugar do AI output",
      "clearOverrides": "Limpar todos os overrides",
      "confirmClearOverrides": "Limpar todos os overrides?",
      "confirmClearOverridesDescription": "Isso remove todos os overrides manuais desta rota.",
      "keyFacts": "Dados-chave",
      "visaStatus": "Status do visto",
      "maxStay": "Permanência máxima",
      "costUsd": "Custo USD",
      "processingTime": "Tempo de processamento",
      "documents": "Documentos",
      "contentLocale": "Idioma do conteúdo: {{locale}}",
      "lastEnriched": "Último enriquecimento: {{ts}}",
      "goalType": "Objetivo: {{goal}}",
      "processSteps": "Passos do processo",
      "noProcessSteps": "Nenhum passo enriquecido encontrado.",
      "where": "Onde:",
      "documentsNeeded": "Documentos necessários:",
      "commonMistakes": "Erros comuns:",
      "links": "Links:",
      "notes": "Notas:",
      "sources": "Fontes",
      "totals": "Totais",
      "totalCost": "Custo total",
      "totalTime": "Tempo total",
      "commonPitfalls": "Armadilhas comuns",
      "successTips": "Dicas de sucesso",
      "overrideFields": "Campos de override",
      "useOverride": "Usar override",
      "useAiOutput": "Usar AI output",
      "costOverride": "Override de custo",
      "timelineOverride": "Override de prazo",
      "documentsOverride": "Override de documentos",
      "tipsOverride": "Override de dicas",
      "pitfallsOverride": "Override de armadilhas",
      "stepsOverride": "Override de passos",
      "addStep": "+ Adicionar passo",
      "listPlaceholder": "Um item por linha",
      "save": "Salvar",
      "cancel": "Cancelar"
    },
    "health": {
      "title": "Saúde",
      "kpiTotalRoutes": "Total de rotas",
      "kpiTotalRoutesHint": "Todas as linhas em visa_metadata",
      "kpiLiveVerified": "Ativas e verificadas",
      "kpiLiveVerifiedHint": "{{pct}}% do catálogo",
      "kpiPendingEnrichment": "Enriquecimento pendente",
      "kpiPendingEnrichmentHint": "À espera do pipeline de IA",
      "kpiPendingReview": "Revisão pendente",
      "kpiPendingReviewHint": "Fila ou marcadas para acompanhamento",
      "coverageOverviewHint": "Parte de todas as rotas por estado de enriquecimento",
      "dataQualityHint": "Métricas de qualidade das rotas live (visíveis)",
      "dqVerifiedShare": "Parte verificada das rotas live",
      "dqAvgConfidence": "Confiança média (live)",
      "dqLowConfidence": "Confiança abaixo de 0,70",
      "dqReviewLowConfidence": "Rever rotas com baixa confiança",
      "sectionApiHealth": "Estado das APIs",
      "apiHealthHint": "Rotas live por fonte LLM, com atividade nos últimos 7 dias",
      "apiSource": {
        "gemini": "Google Gemini",
        "deepseek": "DeepSeek",
        "mistral": "Mistral",
        "openrouter": "OpenRouter",
        "unknown": "Desconhecida"
      },
      "apiSourceRouteCount": "{{count}} rotas",
      "apiActivityOk": "OK",
      "apiActivityStale": "Sem enriquecimentos (7d)",
      "sectionMostUsed": "Rotas mais usadas",
      "mostUsedHint": "Workspaces agrupados por destino e país do passaporte",
      "mostUsedEmpty": "Ainda não há dados suficientes de workspaces",
      "mostUsedLine": "{{origin}} → {{dest}} — {{count}} workspaces",
      "externalTools": "Ferramentas externas",
      "pendingActions": "{{review}} rotas pendentes de revisão · {{enrich}} rotas pendentes de enriquecimento",
      "reviewRoutesCta": "Revisar rotas →",
      "enrichRoutesCta": "Enriquecer rotas →",
      "exchangeRates": "Câmbio",
      "visaData": "Cobertura de dados de visto",
      "enrichmentActivity": "Atividade recente de enriquecimento",
      "verification": "Progresso de verificação",
      "ratesAsOf": "Câmbio em {{date}}",
      "updatedDaysAgo": "Atualizado há {{days}} dias",
      "staleRates": "O câmbio pode estar desatualizado — finanças e valores podem estar incorretos",
      "refreshRates": "Atualizar câmbio agora",
      "refreshSuccess": "Câmbio atualizado.",
      "refreshFailed": "Não foi possível atualizar o câmbio. {{message}}",
      "lastChecked": "Última checagem: {{ts}}",
      "goToQueue": "Ir para a fila de enriquecimento",
      "coverageLine": "Total: {{total}} | Live: {{live}} | Pendente: {{pending}}",
      "verificationLine": "Verificação: {{verified}} verificados | {{pending}} em revisão | {{unverified}} não verificados",
      "verifiedPct": "{{pct}}% das rotas live verificadas",
      "last24hLine": "Últimas 24h: {{enriched}} enriquecidas, {{failed}} falharam",
      "failuresBadge": "{{count}} falhas — verifique logs",
      "viewEnrichmentQueue": "Ver fila de enriquecimento",
      "verificationProgressLine": "{{verified}} de {{live}} rotas live verificadas ({{pct}}%)",
      "pendingReviewLine": "{{count}} rotas pendentes para revisão",
      "goToVerificationQueue": "Ir para a fila de verificação",
      "noIssues": "Tudo parece saudável.",
      "exchangeStatusOk": "OK",
      "exchangeStatusWarning": "Aviso",
      "exchangeStatusError": "Erro",
      "activityHealthy": "OK",
      "externalToolsHint": "Links rápidos para operações.",
      "sectionRouteCoverage": "Cobertura de rotas",
      "sectionDataQuality": "Qualidade dos dados",
      "sectionSystemStatus": "Estado do sistema",
      "routeCoverageEmpty": "Ainda não há rotas em visa_metadata.",
      "routeCoverageRow": {
        "live": "Live (enriquecidas)",
        "pending": "Pendentes de enriquecimento",
        "failed": "Rejeitadas / falha no enriquecimento"
      },
      "verifiedLiveLabel": "Parte das rotas live verificadas",
      "verifiedPctCaption": "Progresso até todas as rotas live estarem verificadas.",
      "verificationDist": {
        "verified": "Verificadas",
        "pendingReview": "Em revisão",
        "unverified": "Não verificadas / não definidas"
      },
      "last24hEnrichedLabel": "Enriquecidas (24h)",
      "last24hFailedLabel": "Falhas (24h)",
      "otherServices": "Outras checagens",
      "emDash": "—",
      "loadError": "Não foi possível carregar a saúde do sistema.",
      "notAllowed": "Não permitido.",
      "toolSupabase": "Painel Supabase",
      "toolVercel": "Painel Vercel",
      "toolSanity": "Sanity Studio",
      "toolGitHub": "Repositório GitHub"
    },
    "visaMetadataImport": "Importar Visa (CSV)",
    "visaMetadataEnrich": "Revisão de passos (visto)",
    "airlines": "Companhias aéreas",
    "blog": "Blog",
    "blogDescription": "Gerencie posts do blog no Sanity Studio",
    "users": {
      "nav": "Utilizadores",
      "emptyTitle": "Gestão de utilizadores",
      "emptyDescription": "Listar contas, funções e convites a partir da área de admin ainda não está disponível."
    },
    "resources": {
      "nav": "Recursos",
      "title": "Recursos",
      "description": "Ligações predefinidas fundidas nos espaços de trabalho consoante o destino.",
      "addResource": "Adicionar recurso",
      "columnTitle": "Título",
      "columnUrl": "URL",
      "columnCategory": "Categoria",
      "columnDestination": "Destino",
      "columnNationality": "Nacionalidade",
      "columnActive": "Ativo",
      "deleteConfirm": "Eliminar este recurso? Esta ação não pode ser anulada.",
      "saveSuccess": "Recurso guardado",
      "deleteSuccess": "Recurso eliminado",
      "searchPlaceholder": "Pesquisar por título ou URL…",
      "filterDestination": "Destino",
      "filterDestinationAny": "Todos os destinos",
      "filterNationality": "Nacionalidade",
      "filterNationalityAny": "Qualquer nacionalidade",
      "filterNationalityAll": "Todas as nacionalidades (sem filtro)",
      "filterCategory": "Categoria",
      "filterCategoryAll": "Todas as categorias",
      "filterDestinationSearch": "Pesquisar destinos…",
      "filterNationalitySearch": "Pesquisar nacionalidades…",
      "filterCategorySearch": "Pesquisar categorias…",
      "statsCardShowAll": "Mostrar todos os recursos — repor filtros",
      "statsCardFilterImmigration": "Filtrar tabela por categoria imigração",
      "statsCardFilterEmbassy": "Filtrar tabela por categoria embaixada",
      "statsCardFilterVisa": "Filtrar tabela por categoria visto",
      "statsCardFilterGeneral": "Filtrar tabela por categoria geral",
      "statsCardFilterActive": "Alternar só recursos ativos",
      "activeOnly": "Só ativos",
      "codesLoading": "A carregar opções de filtro…",
      "statsAria": "Estatísticas de recursos",
      "statsTotal": "Total de recursos",
      "statsImmigration": "Imigração",
      "statsEmbassy": "Embaixada",
      "statsVisa": "Visto",
      "statsGeneral": "Geral",
      "statsActive": "Ativos",
      "showingPaged": "A mostrar {{shown}} de {{total}} recursos",
      "noRecords": "Nenhum recurso encontrado.",
      "noMatch": "Nenhum recurso corresponde à pesquisa.",
      "emptyDescription": "Ajuste os filtros ou adicione um recurso.",
      "allDestinations": "Todos",
      "allNationalities": "Todos",
      "deleteTitle": "Eliminar recurso",
      "edit": "Editar recurso",
      "delete": "Eliminar recurso",
      "category": {
        "immigration": "Imigração",
        "embassy": "Embaixada",
        "visa": "Visto",
        "general": "Geral"
      },
      "form": {
        "addTitle": "Adicionar recurso",
        "editTitle": "Editar recurso",
        "desc": "Estes modelos são fundidos em novos espaços de trabalho quando coincidem destino e nacionalidade.",
        "titleRequired": "O título é obrigatório.",
        "urlRequired": "O URL é obrigatório.",
        "urlInvalid": "Indique um URL http(s) válido.",
        "description": "Descrição",
        "active": "Ativo"
      }
    },
    "checkingAccess": "Checking access…",
    "redirecting": "Redirecting…",
    "logout": "Log out",
    "redirectFailed": "Redirect failed",
    "openingAdmin": "Opening admin…",
    "goToVisaMetadata": "Go to Visa Metadata",
    "usersComingSoon": "Coming soon — admin user management is not implemented yet.",
    "resourcesComingSoon": "Coming soon — admin resources tools are not implemented yet.",
    "waitlist": {
      "nav": "Lista de espera (rotas)",
      "title": "Lista de espera (rotas)",
      "empty": "Ainda sem pedidos de rota.",
      "loading": "A carregar a lista…",
      "columns": {
        "email": "Email",
        "route": "Rota",
        "signedUp": "Registo"
      }
    },
    "testimonials": {
      "nav": "Depoimentos",
      "title": "Depoimentos",
      "banner": "Gerencie depoimentos diretamente no Sanity Studio. Clique em \"Abrir Studio\" para adicionar, editar ou remover.",
      "openStudio": "Abrir Sanity Studio",
      "loading": "Carregando depoimentos…",
      "empty": "Nenhum depoimento encontrado no dataset.",
      "colName": "Nome",
      "colRole": "Cargo",
      "colCompany": "Empresa / país",
      "colRating": "Avaliação",
      "colFeatured": "Na landing"
    }
  },
  "warnings": {
    "staleRates": "Taxas de câmbio de {{date}} — os valores podem ter mudado.",
    "unverifiedVisa": "Gerado por IA — confirme os requisitos com a embaixada ou consulado oficial antes de solicitar.",
    "pendingEnrichment": "Ainda estamos a construir o guia passo a passo para esta rota. Volta em breve."
  },
  "airlinesAdmin": {
    "couldNotLoad": "Não foi possível carregar as companhias aéreas.",
    "updated": "Companhia aérea atualizada.",
    "created": "Companhia aérea criada.",
    "deleted": "Companhia aérea removida.",
    "title": "Companhias aéreas",
    "description": "Gerencie a lista de companhias usada nas tarefas de reserva de voo.",
    "addNew": "Adicionar",
    "searchLabel": "Buscar",
    "searchPlaceholder": "Buscar por nome ou código",
    "loading": "Carregando companhias…",
    "noRecords": "Nenhuma companhia encontrada.",
    "noMatch": "Nenhuma companhia corresponde à busca.",
    "columns": {
      "name": "Nome",
      "iata": "IATA",
      "icao": "ICAO",
      "country": "País",
      "active": "Ativa",
      "sort": "Ordem",
      "actions": "Ações"
    },
    "edit": "Editar",
    "delete": "Excluir",
    "form": {
      "editTitle": "Editar companhia aérea",
      "addTitle": "Adicionar companhia aérea",
      "editDesc": "Atualize e salve.",
      "addDesc": "Crie uma nova entrada.",
      "name": "Nome",
      "iata": "Código IATA",
      "icao": "Código ICAO",
      "country": "País",
      "sort": "Ordem",
      "active": "Ativa",
      "nameRequired": "O nome é obrigatório.",
      "saveFailed": "Falha ao salvar"
    },
    "deleteDialog": {
      "title": "Excluir companhia aérea?",
      "description": "Tem certeza que deseja excluir:",
      "failed": "Falha ao excluir"
    }
  },
  "visaMetadata": {
    "couldNotLoad": "Could not load visa metadata.",
    "updated": "Visa metadata updated.",
    "created": "Visa metadata created.",
    "deleted": "Visa metadata deleted.",
    "title": "Visa metadata",
    "description": "Manage reference rows used by visa checks and onboarding.",
    "enrichmentStatsAria": "Contagens de enriquecimento em todas as linhas de metadados de visto",
    "addNew": "Add New",
    "addMenu": "Adicionar",
    "addManually": "Adicionar manualmente",
    "importCsv": "Importar CSV",
    "searchPlaceholder": "Buscar rotas",
    "searchExample": "ex.: BR, Portugal, work, tourism",
    "searchHint": "Busca em nacionalidade, destino, país, tipo de visto ou objetivo.",
    "searchHintServer": "A busca roda no servidor (com atraso curto). Cobre nacionalidade, destino, país, tipo de visto ou objetivo.",
    "filters": {
      "country": "País",
      "countryPlaceholder": "País de destino",
      "continent": "Continente",
      "continentAll": "Todos os continentes",
      "regionalOrg": "Org. regional",
      "orgsAll": "Todas as orgs.",
      "visaType": "Tipo de visto",
      "visaTypesAll": "Todos os tipos",
      "visaStatus": "Status do visto",
      "statusAll": "Todos os status",
      "clear": "Limpar filtros"
    },
    "summaryTotal": "{{count}} linha(s) correspondente(s).",
    "showingRange": "Linhas {{start}}–{{end}} de {{total}}.",
    "rowsPerPage": "Linhas por página",
    "rowsPerPageAll": "Todas",
    "pageAllRows": "Todas as linhas",
    "pageOf": "Página {{current}} / {{total}}",
    "prevPage": "Anterior",
    "nextPage": "Próxima",
    "loading": "Loading visa metadata…",
    "noRecords": "No records found.",
    "noMatch": "No records match your search.",
    "selectAll": {
      "filteredBanner": "Todas as {{count}} rotas que correspondem aos filtros estão selecionadas."
    },
    "columns": {
      "selectRow": "Selecionar linha",
      "selectCycleStartAria": "Selecionar todas nesta página",
      "selectPartialAria": "Seleção parcial nesta página. Clique para selecionar todas nesta página.",
      "selectPageThenAllAria": "Todas as rotas nesta página estão selecionadas. Clique para selecionar todas as rotas correspondentes ({{count}}).",
      "selectFilteredAllAria": "Todas as {{count}} rotas dos filtros estão selecionadas. Clique para limpar.",
      "route": "De → Para",
      "nationality": "Nacionalidade",
      "destination": "Destino",
      "country": "País",
      "visaType": "Tipo de visto",
      "visaStatus": "Estado do visto",
      "status": "Estado",
      "enrichment": "Enriquecimento",
      "source": "Origem",
      "sources": "Fontes",
      "enriched": "Enriquecido",
      "nationalityCurrency": "Moeda nat.",
      "verification": "Verificação",
      "contentLocale": "Locale",
      "createdAt": "Criada em",
      "updatedAt": "Atualizada em",
      "actions": "Ações",
      "rowActionsAria": "Ações da linha"
    },
    "filterContinentLabel": "Continente",
    "filterContinentAll": "Todos os continentes",
    "enrichmentFilterLabel": "Enriquecimento",
    "enrichmentFilterAll": "Todos",
    "enrichmentFilterLive": "Ao vivo",
    "enrichmentFilterPending": "Pendente",
    "enrichmentFilterRejected": "Rejeitado",
    "enrichmentFilterNotEnriched": "Sem data de enriquecimento",
    "enrichmentStatus": {
      "none": "Nenhum",
      "live": "Ao vivo",
      "pending": "Pendente",
      "rejected": "Rejeitado",
      "approved": "Aprovado",
      "enriching": "A enriquecer"
    },
    "enrichedToday": "Hoje {{time}}",
    "enrichedDaysAgo_one": "Há 1 dia",
    "enrichedDaysAgo_other": "Há {{count}} dias",
    "batchEnrich": "Enriquecer em lote",
    "batchEnrichTitle": "Enriquecimento em lote",
    "batchEnrichPhaseFetch": "A selecionar até 10 rotas pendentes com passos vazios…",
    "batchEnrichPhaseEnrich": "A chamar o serviço de enriquecimento (pode demorar um minuto)…",
    "batchEnrichPhaseDone": "A concluir…",
    "batchEnrichWorking": "A processar…",
    "batchEnrichNoSession": "Tem de iniciar sessão para executar o enriquecimento.",
    "batchEnrichNoRoutes": "Não há rotas pendentes com passos vazios para enriquecer.",
    "batchEnrichFailed": "O enriquecimento em lote falhou.",
    "batchEnrichBadResponse": "Resposta inesperada do serviço de enriquecimento.",
    "batchEnrichToast": "{{succeeded}} com sucesso, {{failed}} falharam.",
    "enrichSelectedNotLoaded": "Não foi possível carregar as linhas selecionadas para enriquecimento.",
    "enrichSelectedTitle": "Enriquecer {{count}} rotas",
    "enrichSelectedTitleDone": "Enriquecimento concluído",
    "enrichSelectedDescription": "Isto vai iniciar o enriquecimento por IA das linhas selecionadas. O processamento pode demorar alguns minutos.",
    "enrichSelectedPhaseFetch": "A carregar as linhas selecionadas…",
    "enrichSelectedPhaseEnrich": "A executar o enriquecimento por IA (pode demorar vários minutos)…",
    "enrichSelectedSummary": "{{succeeded}} com sucesso, {{failed}} falharam.",
    "enrichSelectedRun": "Executar enriquecimento",
    "enrichSelectedNoRouteDetails": "Os resultados por rota não vieram na resposta; veja o resumo acima.",
    "enrichSelectedErrorHint": "O enriquecimento não pôde concluir. Veja os detalhes abaixo.",
    "bulkEnrichAllPublish": "Enriquecer tudo e publicar",
    "bulkEnrichAllTitle": "Enriquecer todas as rotas e publicar ao vivo",
    "bulkEnrichAllDescription": "Todas as rotas com passos vazios são divididas em dois provedores de IA (Mistral e OpenRouter), enriquecidas, gravadas via importação e marcadas como ao vivo. Pode demorar e consome quota de API.",
    "bulkEnrichAllProgress": "{{completed}} / {{total}} rotas enriquecidas",
    "bulkEnrichAllWorking": "A executar dois lotes em paralelo…",
    "bulkEnrichAllAbort": "Parar após a rota atual",
    "bulkEnrichAllClose": "Fechar",
    "pushToLive": "Publicar ao vivo",
    "batchPushToLive": "Publicar aprovadas em lote",
    "pushedToLive": "Rota publicada ao vivo.",
    "batchPushedToLive": "{{count}} rota(s) publicada(s) ao vivo.",
    "pushLiveDialog": {
      "singleTitle": "Publicar ao vivo?",
      "singleConfirm": "Publicar esta rota ao vivo? Os utilizadores verão estes passos.",
      "batchTitle": "Publicar em lote?",
      "batchConfirm": "Publicar {{count}} rota(s) aprovada(s) ao vivo? Os utilizadores verão estes passos.",
      "cancel": "Cancelar",
      "confirm": "Publicar ao vivo",
      "failed": "Não foi possível publicar ao vivo."
    },
    "edit": "Edit",
    "delete": "Delete",
    "form": {
      "editTitle": "Edit visa metadata",
      "addTitle": "Add visa metadata",
      "editDesc": "Update this row and save.",
      "addDesc": "Fill in the fields and create a new row.",
      "nationalityCode": "Nationality code",
      "nationalityError": "Nationality code must be exactly 2 letters.",
      "destinationCode": "Destination code",
      "destinationError": "Destination code must be exactly 2 letters.",
      "destinationCurrency": "Moeda da nacionalidade (ISO 4217, opcional)",
      "destinationCurrencyHint": "Moeda padrão ao criar tarefas de visto para esta rota (depois da moeda do perfil, antes de USD). Muitas vezes a moeda principal do viajante (ex.: EUR). Deixe vazio se não souber.",
      "destinationCurrencyError": "Use um código ISO de 3 letras ou deixe vazio.",
      "country": "Country (display)",
      "goalType": "Goal type",
      "goalRequired": "Goal is required.",
      "visaType": "Visa type",
      "visaTypeRequired": "Visa type is required.",
      "requiredDocs": "Required documents",
      "noDocuments": "No documents listed.",
      "documentName": "Document name",
      "removeDocument": "Remove document",
      "visaStatus": "Visa status",
      "maxStay": "Max stay (days, optional)",
      "cost": "Cost USD (optional)",
      "processingTime": "Processing time (optional)",
      "processingExample": "e.g. 2–4 weeks",
      "note": "Note (optional)",
      "save": "Save",
      "saveFailed": "Save failed",
      "duplicateRoute": "Já existe um registo para essa nacionalidade, destino e tipo de visto.",
      "enrichmentSectionTitle": "Enriquecimento (IA)",
      "enrichmentReadOnlyHint": "Somente leitura. Regenerar passos com enriquecimento em lote ou importação.",
      "enrichmentFieldStatus": "Estado do enriquecimento",
      "enrichmentFieldSource": "Modelo / origem",
      "enrichmentFieldEnrichedAt": "Último enriquecimento",
      "enrichmentNoPayload": "Ainda não há passos guardados para esta rota.",
      "enrichmentNoSteps": "Os passos estão vazios. Execute o enriquecimento para gerar passos de IA.",
      "enrichmentUnparsedHint": "O conteúdo guardado não pôde ser normalizado em passos. Use o JSON bruto abaixo se precisar.",
      "enrichmentShowRaw": "Mostrar JSON bruto",
      "enrichmentHideRaw": "Ocultar JSON bruto",
      "enrichmentStepsTitle": "Passos do processo",
      "enrichmentSourcesTitle": "Fontes oficiais",
      "enrichmentRoutingNotes": "Notas de encaminhamento",
      "enrichmentDelivery": "Entrega do passaporte",
      "enrichmentTotals": "Totais",
      "enrichmentTotalCost": "Total estimado (USD)",
      "enrichmentTotalDays": "Prazo total estimado",
      "enrichmentPitfalls": "Armadilhas comuns",
      "enrichmentTips": "Dicas de sucesso",
      "enrichmentLinkNotFound": "não encontrado",
      "enrichmentStepWhere": "Onde",
      "enrichmentStepDocuments": "Documentos",
      "enrichmentStepLinks": "Ligações",
      "enrichmentStepCost": "Custo do passo (USD)",
      "enrichmentStepDays": "Dias estimados",
      "enrichmentStepNotes": "Notas",
      "enrichmentStepMistakes": "Erros frequentes",
      "enrichmentCityRules": "Regras por cidade (rota)",
      "enrichmentStepCityRules": "Regras por cidade (passo)",
      "enrichmentStepAppliesTo": "Aplica-se a",
      "enrichmentStepRestrictions": "Restrições"
    },
    "deleteDialog": {
      "title": "Delete visa metadata?",
      "confirm": "Are you sure you want to delete {record}? This cannot be undone.",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleteFailed": "Delete failed"
    },
    "rowMenu": {
      "viewEdit": "Ver / Editar",
      "openDetail": "Abrir página de detalhe",
      "enrich": "Enriquecer",
      "reEnrich": "Re-enriquecer",
      "dryRun": "Simulação (dry run)",
      "promote": "Promover",
      "demote": "Rebaixar",
      "demoteHint": "Volta o enriquecimento para pendente. Pode promover de novo depois.",
      "verify": "Verificar",
      "deleteConfirmHint": "Abre uma confirmação. Rotas eliminadas não podem ser recuperadas.",
      "delete": "Eliminar rota"
    },
    "reviewEnrichment": "Rever passos (IA)"
  },
  "visaMetadataEnrich": {
    "title": "Passos do visto — revisar antes de publicar",
    "subtitle": "Revise os passos gerados por IA, publique ao vivo quando estiver pronto ou enriqueça de novo uma rota.",
    "backToList": "Voltar aos metadados de visto",
    "loadingList": "A carregar rotas…",
    "statsError": "Não foi possível carregar as estatísticas.",
    "listError": "Não foi possível carregar as rotas.",
    "statTotal": "Total de rotas",
    "statTotalHint": "Todas as linhas em visa metadata.",
    "statPending": "Pendentes de revisão",
    "statPendingHint": "Na fila antes de publicar.",
    "statApproved": "Aprovadas",
    "statApprovedHint": "Prontas para o próximo passo de publicação.",
    "statLive": "Ao vivo",
    "statLiveHint": "Publicadas para utilizadores.",
    "pendingHeading": "Rotas em espera de revisão",
    "pendingHint": "Use Pré-visualizar para ler os passos, Publicar ao vivo quando os utilizadores devem vê-los, ou Rejeitar para limpar um resultado mau. Pode executar Enriquecer de novo para regenerar os passos.",
    "noPending": "Não há rotas pendentes nem aprovadas em revisão. Quando novas linhas forem enriquecidas, aparecem aqui.",
    "colRoute": "Rota",
    "colStatus": "Estado",
    "badgeEnriched": "Passos IA prontos",
    "colActions": "Ações",
    "preview": "Pré-visualizar",
    "reject": "Rejeitar",
    "enrichOne": "Enriquecer esta rota",
    "rejectedToast": "Rota rejeitada e passos limpos.",
    "rejectFailed": "Falha ao rejeitar.",
    "previewTitle": "Pré-visualização dos passos",
    "previewEmpty": "Ainda não há passos guardados para esta rota. Execute primeiro “Enriquecer esta rota”.",
    "totalCost": "Custo total estimado",
    "totalTime": "Tempo total estimado",
    "stepLabel": "Passo {{n}}",
    "cost": "Custo (USD)",
    "time": "Tempo",
    "documents": "Documentos",
    "close": "Fechar",
    "geminiTitle": "Executar enriquecimento por IA?",
    "geminiBody": "Vamos chamar o serviço seguro de enriquecimento (Google Gemini primeiro, com alternativa automática se necessário). Isto atualiza a base de dados para esta rota quando corre bem.",
    "geminiYes": "Sim, executar",
    "geminiNo": "Cancelar",
    "geminiRunning": "A chamar a IA… pode demorar até um minuto.",
    "enrichSuccessDetail": "Concluído. {{note}}",
    "enrichFailed": "Enriquecimento falhou.",
    "enrichNoResult": "Sem resultado para esta rota.",
    "batchButton": "Enriquecer as próximas 10 rotas pendentes",
    "batchNoPending": "Não há rotas pendentes para enriquecer.",
    "batchTitle": "Enriquecimento em lote",
    "batchRoutesCount": "Até {{count}} rotas neste lote.",
    "batchIntro1": "O passo 1 é um dry run: a IA gera passos mas não grava nada. Revise o resultado e só depois pode gravar as rotas com sucesso.",
    "batchIntro2": "Dica: corrija dados maus na tabela principal de metadados antes de voltar a enriquecer.",
    "runDryRun": "Executar dry run (sem gravar)",
    "cancel": "Cancelar",
    "batchProgressDry": "Dry run em curso — nada está a ser gravado na base de dados.",
    "batchProgressWrite": "A gravar o resultado da IA na base de dados…",
    "batchDrySummary": "Dry run terminado: {{ok}} com sucesso, {{fail}} falharam.",
    "dryRunDone": "Dry run concluído: {{ok}} ok, {{fail}} falharam.",
    "dryRunFailed": "Dry run falhou.",
    "batchWriteSection": "Gravação na base de dados",
    "batchWriteSummary": "Gravação terminada: {{ok}} gravadas, {{fail}} falharam.",
    "writeDone": "Gravado: {{ok}} ok, {{fail}} falharam.",
    "writeFailed": "Gravação falhou.",
    "batchPayloadError": "Uma ou mais rotas não têm dados de requisitos válidos para a IA.",
    "batchNothingToWrite": "Nenhuma rota teve sucesso no dry run, por isso não há nada a gravar.",
    "confirmWrite": "Gravar {{count}} rota(s)",
    "writeConfirmTitle": "Gravar na base de dados?",
    "writeConfirmBody": "Vai gravar passos gerados por IA para {{count}} rota(s). Isto substitui os passos guardados nessas rotas. Continuar?",
    "writeConfirmAction": "Sim, gravar agora"
  },
  "visaMetadataImport": {
    "title": "Visa metadata — importar CSV",
    "description": "Envie um CSV, valide as linhas, revise o preview e faça um upsert em lote via Edge Function.",
    "downloadTemplate": "Baixar modelo CSV",
    "reset": "Limpar",
    "uploadTitle": "Enviar arquivo .csv",
    "uploadHint": "Colunas obrigatórias: nationality_code, destination_code, visa_type, country, goal_type, required_documents (JSON array), visa_status, cost_usd, max_stay, processing_time, note.",
    "noFile": "Nenhum arquivo selecionado",
    "rowsParsed": "Linhas lidas",
    "rowsValid": "Linhas válidas",
    "rowsInvalid": "Erros de validação",
    "validationErrors": "Erros de validação",
    "validationHint": "Corrija o CSV e envie novamente. Validamos enums e tipos para evitar dados ruins em `visa_metadata`.",
    "colRow": "Linha",
    "colField": "Campo",
    "colMessage": "Mensagem",
    "truncatedErrors": "+{{count}} erro(s) não exibido(s)",
    "previewOk": "Preview OK. Pronto para importar.",
    "previewWithErrors": "Há linhas com erros. Apenas linhas válidas serão importadas.",
    "saveEdits": "Salvar edições",
    "editsSaved": "Edições salvas",
    "savedOk": "Edições salvas. Todas as linhas validam.",
    "savedWithErrors": "Edições salvas, mas ainda há {{count}} erro(s) de validação.",
    "functionErrorsTitle": "Erros retornados pelo servidor",
    "functionErrorsHint": "Estas linhas foram rejeitadas pela Edge Function. Corrija os valores acima e tente importar novamente.",
    "importButton": "Importar {{count}} linha(s)",
    "nothingToImport": "Nada para importar (0 linhas válidas).",
    "importSuccess": "Importação concluída: {{inserted}} inseridas, {{updated}} atualizadas.",
    "importPartial": "Importação concluída com avisos: {{inserted}} inseridas, {{updated}} atualizadas, {{failed}} falharam.",
    "importFailed": "Falha na importação.",
    "signInRequired": "Entre novamente para executar a importação.",
    "functionUnreachable": "Não foi possível alcançar o serviço de importação (rede/CORS/bloqueador). Faça o deploy da `visa-import` neste projeto Supabase ou inclua o URL do app em ALLOWED_ORIGINS nessa função.",
    "functionNotDeployed": "Edge Function visa-import não encontrada. Rode: supabase functions deploy visa-import",
    "truncatedPreview": "+{{count}} linha(s) não exibida(s) no preview"
  },
  "hooks": {
    "bookingAdded": "Reserva adicionada.",
    "bookingRemoved": "Reserva removida.",
    "noAccess": "Workspace não encontrado ou sem permissão de acesso.",
    "fieldAdded": "Campo adicionado.",
    "fieldRemoved": "Campo removido.",
    "onlyOwnerCanCreate": "Somente o dono pode criar campos personalizados.",
    "onlyOwnerCanRemove": "Somente o dono pode remover campos.",
    "resourceAdded": "Recurso adicionado.",
    "resourceRemoved": "Recurso removido.",
    "eventAdded": "Evento adicionado.",
    "eventRemoved": "Evento removido.",
    "itemAdded": "Item adicionado.",
    "itemRemoved": "Item removido.",
    "addedToTimeline": "Adicionado à linha do tempo.",
    "feedbackFailed": "Não foi possível salvar o feedback",
    "customFieldsTableMissing": "A tabela workspace_custom_field_definitions ainda não existe. Rode as migrations no Supabase."
  },
  "modules": {
    "overview": "Visão Geral",
    "tasks": "Tarefas",
    "documents": "Documentos",
    "bookings": "Reservas",
    "packing": "Malas",
    "resources": "Recursos",
    "finances": "Finanças",
    "settings": "Configurações"
  },
  "emptyStates": {
    "tasks": {
      "title": "Nenhuma tarefa ainda",
      "description": "Adicione tarefas ou deixe o sistema criar automaticamente baseado no seu visto.",
      "action": "Adicionar tarefa"
    },
    "tasksFilter": {
      "title": "Nenhuma tarefa encontrada",
      "description": "Tente ajustar os filtros ou pesquisar por outro termo.",
      "clearAction": "Limpar filtros"
    },
    "moduleSearch": {
      "title": "Nenhum resultado",
      "description": "Tente outro termo de busca.",
      "clearAction": "Limpar busca"
    },
    "documents": {
      "title": "Nenhum documento adicionado",
      "description": "Documentos obrigatórios aparecem automaticamente ao criar um workspace com tipo de visto.",
      "action": "Adicionar documento"
    },
    "bookings": {
      "title": "Nenhuma reserva ainda",
      "description": "Adicione reservas manualmente ou importe de emails de confirmação.",
      "action": "Adicionar reserva",
      "secondaryAction": "Importar de email/PDF"
    },
    "packing": {
      "title": "Lista de malas vazia",
      "description": "Adicione itens ou deixe o sistema sugerir com base no seu destino.",
      "action": "Adicionar item"
    },
    "resources": {
      "title": "Nenhum recurso salvo",
      "description": "Salve links úteis sobre visto, moradia, banco e mais.",
      "action": "Adicionar recurso"
    },
    "resourcesSearch": {
      "title": "Nenhum recurso encontrado",
      "description": "Tente outro termo ou limpe os filtros.",
      "clearAction": "Limpar busca e filtros"
    },
    "dashboard": {
      "title": "Crie seu primeiro plano",
      "description": "Organize sua mudança, estudo ou viagem em um só lugar."
    }
  },
  "bookings": {
    "searchPlaceholder": "Buscar reservas…",
    "viewLayoutLabel": "Visualização das reservas",
    "viewList": "Lista",
    "viewCalendar": "Calendário",
    "newBooking": "Nova reserva",
    "addBooking": "Adicionar reserva",
    "editBooking": "Editar reserva",
    "noBookingsTitle": "Nenhuma reserva ainda",
    "noBookingsDesc": "Rastreie voos, acomodação, carros, consulados e outras reservas.",
    "addFirstBooking": "Adicionar reserva",
    "titleLabel": "Título",
    "titlePlaceholder": "Ex: Voo GRU → LIS",
    "typeLabel": "Tipo",
    "statusLabel": "Status",
    "providerLabel": "Provedor",
    "providerPlaceholder": "Ex: GOL, Airbnb, Hertz",
    "dateLabel": "Data / Partida",
    "checkoutDateLabel": "Data final (opcional)",
    "confirmationLabel": "Confirmação / Ref",
    "confirmationPlaceholder": "PNR, código de reserva...",
    "costLabel": "Custo",
    "currencyLabel": "Moeda",
    "notesLabel": "Notas",
    "notesPlaceholder": "Detalhes adicionais...",
    "typeFlight": "Voo",
    "typeAccommodation": "Acomodação",
    "typeCar": "Carro",
    "typeAppointment": "Consulado / Appt.",
    "typeOther": "Outro",
    "statusPending": "Pendente",
    "statusConfirmed": "Confirmado",
    "statusCancelled": "Cancelado",
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "create": "Adicionar",
    "conf": "Conf",
    "groupByType": "Por tipo",
    "groupByDate": "Por data"
  },
  "finances": {
    "emptyState": {
      "title": "Nenhum orçamento definido ainda",
      "description": "Adicione um orçamento total para acompanhar o progresso dos gastos.",
      "descriptionWithCosts": "Você já tem custos registrados — adicione um orçamento total para acompanhá-los.",
      "cta": "Definir orçamento"
    },
    "searchPlaceholder": "Buscar no detalhamento de custos…",
    "noBudgetSetTitle": "Nenhum orçamento definido ainda",
    "noBudgetSetDesc": "Adicione um orçamento total para acompanhar o progresso dos gastos.",
    "noBudget": "Ainda não há orçamento da viagem",
    "noBudgetTrackHint": "Nenhum orçamento definido — adicione um orçamento total para acompanhar os gastos.",
    "noBudgetDesc": "Defina um orçamento total para acompanhar gastos em tarefas, reservas e custos da linha do tempo.",
    "setBudget": "Definir um orçamento",
    "budgetWarning": "Você já usou a maior parte do orçamento da viagem. Revise os custos antes de adicionar mais.",
    "overBudget": "Os custos comprometidos ultrapassam o orçamento da viagem. Ajuste o orçamento ou reduza gastos.",
    "noItemsWithCost": "Nenhum item com custo nesta categoria.",
    "totalBudget": "Orçamento total",
    "committed": "Comprometido",
    "remaining": "Restante",
    "breakdownTitle": "Detalhamento de custos",
    "groupTasks": "Tarefas",
    "groupBookings": "Reservas",
    "groupTimeline": "Linha do tempo",
    "subtotal": "Subtotal",
    "fxApproxHint": "Conversão aproximada ({{source}}), taxas Frankfurter em {{date}}.",
    "fxSourceCached": "taxas em cache",
    "fxSourceLive": "taxas ao vivo",
    "subtotalCurrency": "Subtotal ({{currency}})",
    "costCertainty": {
      "estimated": "Estimado",
      "unknown": "Custo desconhecido",
      "verified": "Valor verificado",
      "user": "Informado por você"
    },
    "overviewTitle": "Visão do orçamento",
    "overviewSubtitle": "O comprometido inclui tarefas com custo registrado. Valores estimados aparecem separados das taxas verificadas.",
    "staleRatesBadge": "Câmbio desatualizado",
    "amountLabel": "Valor total",
    "currency": "Moeda",
    "notesLabel": "Observações",
    "notesPlaceholder": "Observações opcionais…",
    "saveBudget": "Salvar orçamento",
    "budgetSaved": "Orçamento salvo.",
    "editBudget": "Editar orçamento",
    "cancel": "Cancelar",
    "validationAmount": "Informe um valor de orçamento válido (0 ou maior).",
    "saveFailed": "Não foi possível salvar o orçamento.",
    "healthTitle": "Orçamento da Viagem",
    "noBudgetShort": "Orçamento não definido",
    "goToFinances": "Definir orçamento →",
    "viewFinancesCta": "Ver finanças →",
    "healthCommittedBetween": "de",
    "healthCommittedSuffix": "comprometidos",
    "healthRemaining": "{{amount}} restantes",
    "ratesLoading": "As taxas de câmbio estão carregando; tente novamente em instantes.",
    "fxLoadingOptions": "Carregando lista de moedas…",
    "overviewFxLoading": "Carregando taxas de câmbio…",
    "convertingCosts": "Convertendo custos de tarefas e da linha do tempo para {{currency}}…",
    "totalTasksInWorkspaceCurrency": "Total em {{currency}} (tarefas)",
    "ratesAsOf": "Taxas em {{date}}",
    "ratesLastUpdated": "Taxas de câmbio atualizadas em {{date}}",
    "equationTasks": "Tarefas",
    "equationBookings": "Reservas e eventos",
    "equationTotal": "Total comprometido",
    "equationFootnote": "Convertido para {{currency}} com as taxas armazenadas.",
    "timelineEmptyHelper": "Custos de tarefas e itens da linha do tempo com valor aparecem aqui quando você informar os valores.",
    "timelineEmptyTasksCta": "Abrir tarefas",
    "notConvertedAmount": "{{amount}} (não convertido)",
    "notConvertedMissingRate": "Sem taxa de câmbio para a moeda de exibição.",
    "exchangeRatesLoadError": "Não foi possível carregar taxas de câmbio para os totais.",
    "overBudgetShort": "Acima do orçamento",
    "unknownCostsHint": "{{count}} tarefa(s) com custo desconhecido ou não confirmado (não contadas como R$ 0).",
    "fxIncompleteHint": "Alguns custos não puderam ser convertidos para a moeda do orçamento e ficam fora do total de progresso."
  },
  "packing": {
    "searchPlaceholder": "Buscar na lista de malas…",
    "viewLayoutLabel": "Visualização da mala",
    "viewChecklist": "Checklist",
    "viewGrid": "Grade",
    "newItem": "Novo item",
    "addItem": "Adicionar item",
    "editItem": "Editar item",
    "noItemsTitle": "Lista vazia",
    "noItemsDesc": "Adicione itens para não esquecer nada na sua mudança.",
    "addFirstItem": "Adicionar item",
    "itemLabel": "Item",
    "itemPlaceholder": "Ex: Passaporte",
    "categoryLabel": "Categoria",
    "quantityLabel": "Quantidade",
    "notesLabel": "Notas",
    "notesPlaceholder": "Observações...",
    "packed": "Embalado",
    "unpack": "Desmarcar",
    "overallProgress": "{{packed}} de {{total}} itens embalados",
    "allPacked": "Tudo embalado! 🎉",
    "categoryProgress": "{{packed}}/{{total}}",
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "create": "Adicionar",
    "catDocumentos": "Documentos",
    "catRoupas": "Roupas",
    "catEletronicos": "Eletrônicos",
    "catMedicamentos": "Medicamentos",
    "catHigiene": "Higiene",
    "catDinheiro": "Dinheiro",
    "catOutros": "Outros"
  },
  "resources": {
    "viewLayoutLabel": "Visualização dos recursos",
    "viewGrid": "Grade",
    "viewList": "Lista",
    "viewSearch": "Busca",
    "newResource": "Novo recurso",
    "addResource": "Adicionar recurso",
    "editResource": "Editar recurso",
    "noResourcesTitle": "Nenhum recurso ainda",
    "noResourcesDesc": "Salve links úteis como sites de visto, grupos da comunidade, guias e ferramentas.",
    "addFirstResource": "Adicionar recurso",
    "titleLabel": "Título",
    "titlePlaceholder": "Ex: Portal da AIMA",
    "urlLabel": "URL",
    "urlPlaceholder": "https://...",
    "categoryLabel": "Categoria",
    "descriptionLabel": "Descrição",
    "descriptionPlaceholder": "Para que serve este recurso?",
    "isFavoriteLabel": "Favorito",
    "searchPlaceholder": "Buscar recursos...",
    "destinationFor": "Recursos para {{destination}}",
    "destinationPrioritized": "Priorizados para {{destination}} — use “Todos os recursos” para ver tudo.",
    "destinationFilterDestination": "Só destino",
    "destinationFilterAll": "Todos os recursos",
    "destinationEmptyTitle": "Nenhum recurso corresponde a este destino",
    "destinationEmptyDescription": "Use “Todos os recursos” para ver todos os links salvos ou adicione links que mencionem o destino no título, categoria ou descrição.",
    "destinationEmptyAction": "Mostrar todos os recursos",
    "allCategories": "Todas as categorias",
    "favoritesOnly": "Só favoritos",
    "openLink": "Abrir",
    "favorite": "Favoritar",
    "unfavorite": "Desfavoritar",
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "create": "Adicionar",
    "catVisto": "Visto",
    "catMoradia": "Moradia",
    "catBancario": "Bancário",
    "catSaude": "Saúde",
    "catTransporte": "Transporte",
    "catEducacao": "Educação",
    "catOutros": "Outros",
    "noResults": "Nenhum resultado encontrado"
  },
  "itinerary": {
    "typeVisa": "Consulado / Visto",
    "typeFlight": "Voo",
    "typeAccommodation": "Acomodação",
    "typeBank": "Banco",
    "typeHealth": "Saúde",
    "typeSchool": "Escola / Universidade",
    "typeCustom": "Outro"
  },
  "docs": {
    "autoGeneratedBanner": "Estes documentos são gerados automaticamente a partir das suas tarefas de visto. Para editar requisitos, vá a <tasks>Tarefas</tasks>.",
    "visaRequirementsFromTasks": "Requisitos de visto (das tarefas)",
    "searchPlaceholder": "Buscar documentos…",
    "uploadTitle": "Arraste arquivos aqui ou clique para fazer upload",
    "uploadSubtitle": "Suporta PDF, JPG, PNG (máx. 10MB por arquivo)",
    "uploadButton": "Selecionar arquivos",
    "uploadSuccess": "Arquivo adicionado",
    "linkedTasksCount_one": "Vinculado a {{count}} tarefa",
    "linkedTasksCount_other": "Vinculado a {{count}} tarefas",
    "uploadSizeError": "Arquivo muito grande (máx. 10MB)",
    "viewLayoutLabel": "Visualização dos documentos",
    "viewChecklist": "Checklist",
    "viewTable": "Tabela",
    "viewProgress": "Progresso",
    "newDoc": "Novo documento",
    "addDoc": "Adicionar documento",
    "editDoc": "Editar documento",
    "deleteDoc": "Remover documento",
    "confirmDelete": "Remover este documento? Esta ação não pode ser desfeita.",
    "noDocsTitle": "Nenhum documento ainda",
    "noDocsDesc": "Rastreie documentos como passaportes, certidões, comprovantes de renda e mais.",
    "addFirstDoc": "Adicionar documento",
    "nameLabel": "Nome",
    "namePlaceholder": "Ex: Passaporte válido",
    "categoryLabel": "Categoria",
    "categoryPlaceholder": "Selecione uma categoria",
    "statusLabel": "Status",
    "deadlineLabel": "Prazo",
    "notesLabel": "Notas",
    "notesPlaceholder": "Observações sobre este documento...",
    "isRequiredLabel": "Obrigatório",
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Remover",
    "create": "Adicionar",
    "saving": "Salvando…",
    "docAdded": "Documento adicionado.",
    "docSaved": "Documento salvo.",
    "docRemoved": "Documento removido.",
    "toast": {
      "added": "Documento adicionado.",
      "saved": "Documento salvo.",
      "deleted": "Documento removido."
    },
    "statusNeeded": "Pendente",
    "statusInProgress": "Em andamento",
    "statusObtained": "Obtido",
    "statusSubmitted": "Enviado",
    "statusApproved": "Aprovado",
    "catIdentidade": "Identidade",
    "catFinanceiro": "Financeiro",
    "catSaude": "Saúde",
    "catLegal": "Legal",
    "catAlojamento": "Alojamento",
    "catEducacao": "Educação",
    "catOutros": "Outros",
    "deadline": "Prazo",
    "overdue": "Atrasado",
    "daysLeft": "{{n}} dias",
    "required": "Obrigatório",
    "optional": "Opcional",
    "colName": "Documento",
    "colCategory": "Categoria",
    "colStatus": "Status",
    "colDeadline": "Prazo",
    "colNotes": "Notas",
    "colActions": "Ações",
    "progressTitle": "Progresso por categoria",
    "overallProgress": "Progresso geral",
    "totalDocs": "{{done}}/{{total}} documentos"
  },
  "documents": {
    "infoBanner": {
      "text": "Estes documentos são gerados automaticamente a partir das tarefas do visto. Para editá-los, abra a visualização de Tarefas.",
      "cta": "Ir para Tarefas",
      "dismissAria": "Dispensar aviso"
    }
  },
  "tasks": {
    "viewLayoutLabel": "Visualização das tarefas",
    "aiGeneratedWarning": "Tarefas baseadas em dados de IA — verifique os requisitos.",
    "viewList": "Lista",
    "viewKanban": "Kanban",
    "viewCalendar": "Calendário",
    "viewGantt": "Linha do tempo (Gantt)",
    "viewTable": "Tabela",
    "gantt": {
      "groupBySection": "Seção",
      "groupByCategory": "Categoria",
      "groupByNone": "Nenhum",
      "groupByLabel": "Agrupar por",
      "allTasksLane": "Todas as tarefas",
      "noSection": "Sem seção"
    },
    "ganttEmptyWorkspace": "Ainda não há tarefas neste workspace.",
    "ganttNoDueDates": "Nenhuma tarefa tem prazo. Defina um prazo na ficha da tarefa e ela aparecerá nesta linha do tempo.",
    "ganttNoDateSection": "Tarefas sem prazo",
    "searchPlaceholder": "Buscar tarefas…",
    "bulk": {
      "selected": "{{count}} selecionada(s)",
      "markDone": "Marcar como concluídas",
      "delete": "Excluir selecionadas",
      "clear": "Limpar seleção"
    },
    "pagination": {
      "rowsPerPage": "Linhas por página",
      "page": "Página {{current}}",
      "of": "de {{total}}",
      "prev": "Anterior",
      "next": "Próxima"
    },
    "table": {
      "selectAllPage": "Selecionar todas nesta página",
      "selectRow": "Selecionar “{{title}}”"
    },
    "meta": {
      "cost": "{{amount}} USD",
      "due": "{{date}}"
    },
    "listDescriptionShowMore": "Ver mais",
    "sectionTodo": "A fazer",
    "sectionInProgress": "Em andamento",
    "sectionDone": "Concluído",
    "sectionGeneral": "Geral",
    "sectionHeaderTaskCount_other": "{{count}} tarefas",
    "sectionHeaderTaskCount_one": "{{count}} tarefa",
    "priorityNone": "Sem prioridade",
    "priorityLow": "Baixa",
    "priorityMedium": "Média",
    "priorityHigh": "Alta",
    "priorityUrgent": "Urgente",
    "dueToday": "Hoje",
    "dueTomorrow": "Amanhã",
    "overdue": "Atrasado",
    "addTask": "Adicionar tarefa",
    "newTask": "Nova tarefa",
    "extractedFromDocument": "Extraído do documento",
    "fillFromDoc": "Extrair de um documento",
    "fillFromDocHint": "Cole um email, PDF ou texto com a tarefa…",
    "fillFromDocSuccess": "Campos preenchidos! Revise e salve.",
    "fillFromDocError": "Não foi possível extrair uma tarefa. Tente com um texto mais detalhado.",
    "fillFromDocFileTooLarge": "Arquivo muito grande. Tamanho máximo: 10 MB.",
    "fillFromDocFileType": "Tipo de arquivo não suportado. Use PDF, JPG, PNG ou WebP.",
    "fillFromDocRemoveFile": "Remover arquivo",
    "documents": {
      "sectionTitle": "Documentos",
      "attachExisting": "Anexar documento existente",
      "uploadAndAttach": "Enviar e anexar",
      "noDocuments": "Nenhum documento vinculado ainda.",
      "detach": "Remover vínculo",
      "searchPlaceholder": "Buscar documentos…",
      "attachSelected": "Anexar selecionados",
      "uploading": "Enviando…"
    },
    "tips": {
      "toggle": "Dicas",
      "successTitle": "Dicas de sucesso",
      "mistakesTitle": "Erros comuns"
    },
    "editTask": "Editar tarefa",
    "deleteTask": "Excluir tarefa",
    "confirmDelete": "Excluir esta tarefa? Essa ação não pode ser desfeita.",
    "titleLabel": "Título",
    "titlePlaceholder": "Nome da tarefa",
    "descriptionLabel": "Descrição",
    "descriptionPlaceholder": "Adicione uma descrição...",
    "cost": "Custo",
    "currency": "Moeda",
    "costHint": "Este custo será contabilizado no orçamento da viagem",
    "dueDateLabel": "Data limite",
    "fields": {
      "dateRangeLabel": "Intervalo de datas",
      "dateRangeHelp": "Escolha um único dia ou um intervalo.",
      "planningDateHint": "Esta data é uma recomendação de planejamento do Wundrlst, não um prazo do governo.",
      "leanScheduleHint": "Use o intervalo de datas acima para viagem, estadia ou compromissos. Datas antigas por campo podem ainda existir nos dados salvos.",
      "leanCostHint": "Use o custo acima para taxas e totais. Campos de preço da categoria podem ainda existir nos dados salvos, mas ficam ocultos aqui."
    },
    "priorityLabel": "Prioridade",
    "sectionLabel": "Seção",
    "sectionPlaceholder": "Ex: Visto, Moradia...",
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "create": "Criar",
    "saving": "Salvando…",
    "deleting": "Excluindo…",
    "taskCreated": "Tarefa criada.",
    "taskSaved": "Tarefa salva.",
    "taskDeleted": "Tarefa excluída.",
    "toast": {
      "created": "Tarefa criada.",
      "saved": "Tarefa salva.",
      "completedWithUndo": "Tarefa concluída",
      "statusUpdated": "Status atualizado",
      "deleted": "Tarefa excluída",
      "deletedWithUndo": "Tarefa excluída"
    },
    "validationTitle": "Informe o título da tarefa para continuar",
    "validationCategoryFieldRequired": "{{field}} é obrigatório",
    "validationCategoryInvalidUrl": "Informe uma URL válida",
    "validationCategoryInvalidEmail": "Informe um e-mail válido",
    "validationCategoryInvalidPhone": "Informe um telefone válido",
    "validationCategoryInvalidTime": "Use o horário no formato HH:MM (ex.: 14:30)",
    "validationCategoryInvalidNumber": "Informe um número válido",
    "validationCategoryNumberRange": "O número está fora do intervalo permitido",
    "validationCategoryLengthMin": "{{field}} é curto demais",
    "validationCategoryLengthMax": "{{field}} é longo demais",
    "noTasks": "Nenhuma tarefa ainda",
    "noTasksDesc": "As tarefas ajudam você a rastrear cada passo — desde aplicação de visto até reservar voos.",
    "addFirstTask": "Adicionar primeira tarefa",
    "unscheduled": "Sem data",
    "colTitle": "Título",
    "colSection": "Seção",
    "colPriority": "Prioridade",
    "colDueDate": "Data limite",
    "colStatus": "Status",
    "colActions": "Ações",
    "edit": "Editar",
    "mon": "Seg",
    "tue": "Ter",
    "wed": "Qua",
    "thu": "Qui",
    "fri": "Sex",
    "sat": "Sáb",
    "sun": "Dom"
  },
  "auth": {
    "signIn": "Entrar",
    "signUp": "Criar conta",
    "email": "Email",
    "password": "Senha",
    "fullName": "Nome completo",
    "continueWithGoogle": "Continuar com Google",
    "continueWithApple": "Continuar com Apple",
    "verifyEmail": "Verifique seu email",
    "verifyEmailDesc": "Enviamos um link de verificação para",
    "resendEmail": "Reenviar email",
    "emailVerified": "Email verificado!",
    "acceptTerms": "Você deve aceitar os termos para continuar.",
    "welcomeBack": "Bem-vindo de volta",
    "welcomeBackDesc": "Entre na sua conta Wundrlst para continuar.",
    "createAccount": "Criar sua conta",
    "createAccountDesc": "Comece seu primeiro espaço Wundrlst em minutos.",
    "forgotPassword": "Esqueceu sua senha?",
    "forgotPasswordTitle": "Esqueci a senha",
    "forgotPasswordDesc": "Enviaremos um link seguro por email para você definir uma nova senha.",
    "sendResetLink": "Enviar link de redefinição",
    "sendingReset": "Enviando…",
    "resetEmailSentTitle": "Confira seu email",
    "resetEmailSentMessage": "Se existir uma conta para {{email}}, você receberá um email com o link de redefinição.",
    "backToSignIn": "Voltar ao login",
    "rememberedPassword": "Lembrou da senha?",
    "resetEmailError": "Não foi possível enviar o email de redefinição.",
    "enterPassword": "Digite sua senha",
    "passwordMinLength": "Pelo menos 8 caracteres",
    "passwordHint": "Use pelo menos 8 caracteres.",
    "signingIn": "Entrando…",
    "login": "Entrar",
    "creating": "Criando…",
    "or": "ou",
    "iAccept": "Eu aceito os",
    "termsConditions": "Termos e Condições",
    "andThe": "e a",
    "privacyLink": "Política de Privacidade",
    "backToHome": "← Voltar ao início",
    "signupVerifyBannerTitle": "Confira seu email",
    "signupVerifyBannerBody": "Enviamos um link de verificação para {{email}}. Abra-o para confirmar sua conta.",
    "signupVerifyBannerHint": "O link expira em 24 horas.",
    "signupVerifyBannerGoToSignIn": "Entrar depois de verificar →"
  },
  "blogPost": {
    "notFoundTitle": "Artigo não encontrado",
    "notFoundDesc": "Não encontramos esse artigo. Ele pode ter sido removido ou o CMS ainda não está configurado.",
    "backToBlog": "Voltar ao blog",
    "home": "Início",
    "minRead": "{{count}} min de leitura",
    "publishedOn": "Publicado em",
    "backToBlogLink": "← Voltar ao blog",
    "bodySoon": "Conteúdo completo em breve — adicione o corpo do post no Sanity Studio."
  },
  "blog": {
    "category": {
      "fallback": "Blog",
      "all": "Todos",
      "visto": "Visto",
      "moradia": "Moradia",
      "financas": "Finanças",
      "destinos": "Destinos",
      "dicas": "Dicas",
      "comunidade": "Comunidade",
      "vistos": "Vistos",
      "relocation": "Relocation"
    },
    "list": {
      "title": "Blog {{app}}",
      "intro": "Guias práticos sobre vistos, mudança e destinos — não são assessoria jurídica, apenas contexto para organizar sua viagem.",
      "configureHintPrefix": "Novos posts em breve. Configure",
      "configureCode": "VITE_SANITY_PROJECT_ID",
      "configureHintSuffix": "no ambiente para carregar postagens do CMS.",
      "emptySoon": "Novos posts em breve.",
      "prev": "Anterior",
      "next": "Próxima",
      "page": "Página {{current}} de {{total}}"
    }
  },
  "legal": {
    "termsTitle": "Termos e Condições",
    "privacyTitle": "Política de Privacidade",
    "cookiesTitle": "Política de Cookies",
    "breadcrumbHome": "Início",
    "breadcrumbTerms": "Termos de Uso",
    "breadcrumbPrivacy": "Política de Privacidade",
    "breadcrumbCookies": "Política de Cookies",
    "lastUpdated": "Última atualização: {{date}}",
    "lastUpdatedPlaceholder": "Última atualização: a publicar.",
    "backToHome": "← Voltar ao início",
    "contentSoon": "O conteúdo completo será publicado em breve.",
    "dialogDescription": "Visualização do documento legal",
    "openFullPage": "Abrir página completa em nova aba"
  },
  "common": {
    "undo": "Desfazer",
    "linkCopied": "Link copiado",
    "linkCopyFailed": "Não foi possível copiar o link",
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "edit": "Editar",
    "add": "Adicionar",
    "search": "Buscar",
    "loading": "Carregando...",
    "error": "Algo deu errado",
    "retry": "Tentar novamente",
    "done": "Concluído",
    "view": "Ver",
    "close": "Fechar",
    "confirm": "Confirmar",
    "yes": "Sim",
    "no": "Não",
    "back": "Voltar"
  },
  "views": {
    "list": "Lista",
    "kanban": "Kanban",
    "calendar": "Calendário",
    "table": "Tabela",
    "timeline": "Linha do tempo",
    "grid": "Grade"
  },
  "verifyBanner": {
    "message": "Verifique seu email",
    "description": "Enviamos um link de verificação para",
    "resend": "Reenviar email",
    "resending": "Enviando...",
    "resent": "Email reenviado! ✓",
    "error": "Erro ao enviar. Tente novamente.",
    "dismiss": "Fechar"
  },
  "language": {
    "toggle": "Idioma",
    "pt": "PT",
    "en": "EN"
  },
  "landing": {
    "hero": {
      "eyebrow": "Wundrlst",
      "title": "A sua mudança, planeada. Passo a passo.",
      "subtitle": "Diz-nos de onde és e para onde vais. Tratamos do resto — vistos, tarefas, documentos e orçamento.",
      "statsLine": "500+ rotas · 30+ nacionalidades · 80+ destinos",
      "signUp": "Criar conta",
      "signIn": "Entrar",
      "bookDemo": "Agendar demo",
      "imageAltFromCms": "Imagem principal do Wundrlst",
      "imageAltStock": "Foto ilustrativa de banco de imagens — não é captura do app Wundrlst."
    },
    "features": {
      "eyebrow": "Por que o Wundrlst",
      "title": "Estrutura para um processo caótico",
      "subtitle": "Mudanças longas e viagens curtas exigem coordenação. O Wundrlst te dá uma superfície calma para acompanhar o que importa — sem substituir assessoria jurídica.",
      "card1Title": "Um workspace por mudança",
      "card1Desc": "Um espaço dedicado para cada viagem ou mudança. Vistos, documentos, recursos salvos, tarefas e orçamento — conectados em um lugar só.",
      "card2Title": "Controle de prazos",
      "card2Desc": "Tarefas têm datas. Veja o que vence a seguir antes de virar urgente — consulado, renovação de contrato ou uma data importante da viagem.",
      "card3Title": "Privado por padrão",
      "card3Desc": "Row-level security mantém cada workspace vinculado à sua conta. Seus documentos sensíveis ficam só seus.",
      "card4Title": "Checklists a partir dos dados de visto",
      "card4Desc": "Informe passaporte, destino e tipo de visto — geramos tarefas quando a rota existe na base. Edite tudo para o seu caso.",
      "firstVisualScreenshotAlt": "Captura de tela do workspace Wundrlst",
      "illustrativePhotoAlt": "Foto ilustrativa: {{title}}"
    },
    "journeys": {
      "eyebrow": "Jornadas",
      "title": "Planos estruturados para mudanças reais",
      "subtitle": "Cada workspace conecta planejamento de visto, documentos, recursos salvos e orçamento — pensado em rotas internacionais, não em listas genéricas.",
      "cta": "Criar conta gratuita"
    },
    "testimonials": {
      "eyebrow": "Depoimentos",
      "title": "O que os primeiros usuários estão dizendo",
      "subtitle": "Depoimentos publicados no Studio aparecem aqui quando houver. Caso contrário, mostramos exemplos curtos e sem atribuição de uso comum — não são depoimentos reais de clientes.",
      "ratingLabel": "{{count}} de 5 estrelas",
      "selectLabel": "Escolher depoimento",
      "dotLabel": "Mostrar depoimento {{index}} de {{total}}",
      "q1": "Paramos de perder PDFs do consulado em chats. Um workspace por mudança deixou os handoffs entre mim e meu parceiro óbvios.",
      "q2": "A primeira lista a partir dos dados de visto nos poupou uma tarde. Editamos tudo — mas não começamos de uma página em branco.",
      "q3": "Datas e tarefas na mesma coluna que documentos parece simples. É — e foi por isso que continuamos usando depois da fase do visto.",
      "q4": "Para uma viagem Schengen mais curta, ocultamos os módulos que não precisávamos. Mesmo produto, menos ruído — exatamente o que queríamos.",
      "fallbackName": "Usuário Wundrlst",
      "fallbackRole": "Acesso antecipado",
      "fallbackCompany": "Exemplo ilustrativo",
      "fallbackQuote1": "Reúna requisitos de visto, documentos e datas da viagem em um workspace em vez de notas e conversas espalhadas.",
      "fallbackQuote2": "Use links salvos e uma visão simples de orçamento junto com tarefas para acompanhar a mudança de ponta a ponta.",
      "fallbackQuote3": "Passe pelo assistente guiado da rota e ajuste tarefas e prazos conforme o plano mudar."
    },
    "cta": {
      "eyebrowFaded": "Pronto quando você estiver.",
      "title": "Organize sua próxima mudança em um workspace",
      "subtitle": "Crie uma conta gratuita e mantenha vistos, documentos e datas em um lugar tranquilo.",
      "createAccount": "Criar conta gratuita",
      "login": "Entrar",
      "bookDemo": "Agendar uma demo"
    },
    "pricing": {
      "eyebrow": "Preços",
      "title": "Comece grátis enquanto aprimoramos o produto",
      "subtitle": "Sem cartão de crédito para explorar. Os preços podem evoluir conforme o Wundrlst cresce — contas iniciais mantêm acesso generoso.",
      "planName": "Wundrlst",
      "planBadge": "Acesso antecipado",
      "planDesc": "Para indivíduos e famílias planejando uma mudança ou viagem estruturada.",
      "perMonth": "/mês",
      "cta": "Começar grátis",
      "included": "O que está incluído:",
      "betaNote": "Inclui os módulos principais do workspace e atualizações nas rotas de visto enquanto estiver em beta.",
      "teamsNote": "Equipes e consultores: conte-nos como você trabalha — estamos de ouvidos para o próximo plano.",
      "feature1": "Workspaces para cada mudança ou viagem",
      "feature2": "Tarefas, documentos, recursos salvos e acompanhamento de orçamento",
      "feature3": "Listas de tarefas e de visto que você ajusta quando quiser",
      "feature4": "Privado na sua conta (RLS)",
      "softDemoCta": "Não tem certeza? Agende uma demo →"
    },
    "visaExplorer": {
      "eyebrow": "Consulta de visto",
      "title": "Confira os requisitos de visto da sua viagem",
      "subtitle": "Consulte mais de 600 rotas sem precisar criar conta"
    },
    "faq": {
      "eyebrow": "FAQ",
      "title": "Perguntas frequentes",
      "subtitle": "Respostas diretas sobre o que o Wundrlst faz — e o que deliberadamente não faz.",
      "q1": "O Wundrlst é assessoria jurídica ou de imigração?",
      "a1": "Não. O Wundrlst é um workspace de planejamento (tarefas, documentos, datas, links). Não substitui advogados, agentes de migração registrados ou orientações oficiais do governo. Confirme sempre os requisitos em embaixadas, consulados ou profissionais qualificados.",
      "q2": "Vocês reservam voos, hotéis ou consultas por mim?",
      "a2": "Não. Você guarda confirmações e datas no seu workspace. O Wundrlst não é agência de viagens, motor de reservas ou serviço de concierge.",
      "q3": "O Wundrlst garante aprovação de visto ou prazos?",
      "a3": "Não. Prazos e dicas de visto exibidos no produto são apenas orientação. Tempos de processamento e regras mudam por país e caso.",
      "q4": "Para quem o Wundrlst foi criado?",
      "a4": "Pessoas coordenando uma mudança internacional séria ou uma viagem estruturada: mudança por trabalho, estudo, família, viagens com visto Schengen ou viagens sem visto. As tarefas sugeridas a partir da rota de visto são ponto de partida — tudo é editável.",
      "q5": "Posso usá-lo só para uma viagem curta de férias?",
      "a5": "Sim. Escolha um foco mais enxuto (por exemplo, viagem curta sem visto ou checklist Schengen) e deixe de lado as áreas do workspace que não precisar.",
      "q6": "O que é que o Wundrlst configura para mim?",
      "a6": "O Wundrlst cria uma área de trabalho personalizada com pedido de visto, documentos, voos, acomodação, orçamento e datas importantes.",
      "q7": "Meus dados são privados?",
      "a7": "Os workspaces estão vinculados à sua conta. O acesso é aplicado com Row Level Security do Supabase, então você lê e escreve apenas suas próprias linhas. Não envie segredos altamente sensíveis a menos que confie no seu dispositivo e rede.",
      "stillQuestions": "Ainda tem dúvidas?",
      "stillQuestionsDesc": "Tem perguntas ou precisa de ajuda? Nossa equipe está aqui para ajudar.",
      "contact": "Fale conosco"
    },
    "blogSection": {
      "tagline": "Guias",
      "heading": "Comece pelos problemas que resolvemos",
      "description": "Leituras curtas sobre planos espalhados, prazos que escapam e manter a viagem em um só workspace — e como o Wundrlst se encaixa no seu fluxo.",
      "seeAll": "Ver todos os posts",
      "readMore": "Ler mais",
      "empty": "Ainda sem artigos — volta em breve.",
      "noCover": "Sem capa",
      "fetchFailed": "Não foi possível carregar os posts do blog. Se continuar, verifique a configuração do Sanity e o console do navegador."
    },
    "footer": {
      "tagline": "Vistos, documentos, tarefas e datas em um workspace tranquilo — para qualquer mudança ou viagem complexa.",
      "copyright": "Todos os direitos reservados.",
      "madeFor": "Feito para quem planeja viagens grandes",
      "features": "Funcionalidades",
      "pricing": "Preços",
      "guides": "Guias",
      "blog": "Blog",
      "faq": "FAQ",
      "contact": "Contato",
      "terms": "Termos",
      "privacy": "Privacidade",
      "cookies": "Cookies",
      "legalNavLabel": "Legal"
    },
    "emptyState": {
      "title": "Crie seu primeiro plano",
      "desc": "Comece planejando sua mudança, intercâmbio ou viagem. Geramos tarefas a partir dos dados de visto quando conhecemos a rota — ou comece do zero.",
      "blank": "Espaço em branco",
      "browse": "Criar workspace"
    }
  },
  "overview": {
    "customize": "Personalizar visão",
    "customizeDescription": "Escolha o que deseja ver na visão geral desta viagem. As preferências são salvas por workspace.",
    "sectionReadiness": "Preparação (anel e barras)",
    "sectionInsights": "O que fazer agora",
    "sectionTasks": "Tarefas",
    "sectionDocuments": "Documentos",
    "sectionBookings": "Reservas",
    "sectionPacking": "Bagagem",
    "sectionResources": "Recursos",
    "resetDefault": "Mostrar tudo",
    "close": "Concluir",
    "allHidden": "Todas as seções da visão geral estão ocultas. Restaure o layout padrão para ver tarefas, documentos, recursos e mais.",
    "customizeHint": "Personalizar",
    "urgencyUrgent": "Urgente",
    "urgencyAttention": "Atenção",
    "resetLayout": "Restaurar layout padrão",
    "statTasks": "{{count}} tarefas",
    "statDocuments": "{{count}} documentos",
    "statEvents": "{{count}} eventos",
    "statBookings": "{{count}} reservas",
    "statPackingItems": "{{count}} itens",
    "statResources": "{{count}} salvos",
    "addTask": "Adicionar tarefa",
    "addDocument": "Adicionar documento",
    "addBooking": "Adicionar reserva",
    "addPackingItem": "Adicionar item",
    "addResource": "Adicionar recurso"
  },
  "workspaceOverviewPage": {
    "visaFreeBannerTitle": "Sem necessidade de visto para a sua viagem",
    "visaFreeBannerBody": "Seu passaporte dá acesso sem visto a {{destination}} segundo dados verificados do Wundrlst. Confirme sempre com a autoridade oficial antes de viajar. Foque no checklist de preparação abaixo.",
    "visaBannerTitle": "Ainda não há dados de visto para esta rota",
    "visaBannerBody": "O Wundrlst ainda não possui metadados de visto para a sua nacionalidade e o destino deste workspace. Confirme sempre com a autoridade competente.",
    "visaBannerOnboarding": "Status de visto salvo no onboarding:",
    "visaBannerCta": "Revisar perfil de visto",
    "visaCardTitle": "Status do visto",
    "cardOpenTasks": "Tarefas em aberto",
    "cardDocumentQueue": "Documentos pendentes",
    "cardSoon": "Em breve",
    "cardCollaborators": "Colaboradores",
    "goToTasksCta": "Ir às tarefas →",
    "viewTasksCta": "Ver tarefas →",
    "routeSnapshot": {
      "title": "Resumo da rota",
      "origin": "Origem",
      "destination": "Destino",
      "visa": "Visto",
      "status": "Status de entrada",
      "processing": "Prazo típico",
      "unknown": "—",
      "loading": "Carregando rota…",
      "mapAria": "Rota de {{origin}} para {{destination}}",
      "weatherHint": "Condições atuais aproximadas (Open-Meteo)",
      "missing": {
        "visa": "Não definido",
        "status": "Não definido",
        "processing": "Indisponível"
      }
    },
    "loading": "Carregando visão geral…",
    "welcomeBannerTitle": "Seu workspace está pronto",
    "welcomeBannerGotIt": "Entendi",
    "welcomeBannerLabels": {
      "tasks": "Tarefas",
      "documents": "Documentos",
      "finances": "Finanças",
      "resources": "Recursos",
      "settings": "Configurações"
    },
    "welcomeBannerHints": {
      "tasksHint": "Checklist de visto e viagem",
      "documentsHint": "Ficheiros e uploads",
      "financesHint": "Orçamento vs custos",
      "resourcesHint": "Links e contactos",
      "settingsHint": "Preferências do workspace"
    },
    "welcomeBannerFooter": "Comece em Tarefas para a checklist.",
    "tasksCardTitle": "Conclusão de tarefas",
    "tasksCardFraction": "{{done}} / {{total}}",
    "progressScaleStart": "0%",
    "progressScaleEnd": "100%",
    "nextCostTitle": "Próximo custo a vencer",
    "nextCostDue": "Data de vencimento",
    "nextCostAmount": "Valor",
    "nextCostEmpty": "Nenhuma tarefa futura com custo e data.",
    "nextCostDaysUntil_one": "{{count}} dia até o vencimento",
    "nextCostDaysUntil_other": "{{count}} dias até o vencimento",
    "categoryBreakdownTitle": "Tarefas por categoria",
    "statusDistributionTitle": "Tarefas por estado",
    "statusDonutAria": "Distribuição de estados das tarefas",
    "taskStatus": {
      "todo": "A fazer",
      "in_progress": "Em progresso",
      "done": "Concluídas"
    },
    "categories": {
      "visa_application": "Pedido de visto",
      "document_collection": "Recolha de documentos",
      "accommodation": "Alojamento",
      "flight_booking": "Voos",
      "rental_car": "Carro alugado",
      "appointment": "Marcação",
      "bank_account": "Conta bancária",
      "registration": "Registo",
      "moving_logistics": "Logística da mudança",
      "general": "Geral"
    },
    "collaboratorFallback": "Utilizador",
    "stickyBarAria": "Resumo do workspace",
    "voaBannerTitle": "Visto na chegada — não é isenção de visto",
    "voaBannerBody": "Para {{destination}}, você ainda precisa obter um visto na fronteira ou no aeroporto. Podem haver taxas e documentos. Confirme com a autoridade do destino antes de viajar.",
    "officialSourceLink": "Abrir fonte oficial",
    "visaTrustLastVerified": "Última verificação {{date}}",
    "routeTrustTitle": "Requisitos da rota",
    "routeTrustVerified": "Dados de rota verificados para {{destination}} ({{visa}}). Confirme sempre com a autoridade oficial antes de viajar.",
    "routeTrustLastReviewed": "Última revisão: {{date}}",
    "routeTrustNoOfficialUrl": "Ainda não há URL de fonte oficial armazenada para esta rota.",
    "routeTrustNeedsAttention": "{{count}} tarefas abertas precisam de atenção (atrasadas ou alta prioridade).",
    "documentsCardFraction": "{{pending}} pendentes · {{total}} no total",
    "documentsCardEmpty": "Nenhum documento gerado ainda. Adicione o que esta rota exige.",
    "documentsCardHint": "Documentos ligados ao seu checklist de preparação.",
    "viewDocumentsCta": "Ver documentos →",
    "nextCostInline": "Próximo custo: {{title}} · {{amount}} · {{date}}"
  },
  "chatbot": {
    "minimized": "Assistente",
    "title": "Assistente Wundrlst",
    "settings": "Configurações",
    "close": "Fechar",
    "settingsSummaryTitle": "Configurações do assistente",
    "settingsSummaryDesc": "Tópicos, tom e fontes são configurados por workspace.",
    "openFullSettings": "Abrir configurações completas",
    "clearLocal": "Limpar histórico",
    "empty": "Faça uma pergunta sobre suas tarefas, documentos ou prazos.",
    "sources": "Fontes",
    "voteHelpful": "Útil",
    "voteNotHelpful": "Não útil",
    "copy": "Copiar",
    "copied": "Copiado ✓",
    "copyFailed": "Não foi possível copiar.",
    "typing": "O assistente está a digitar",
    "retry": "Tentar novamente",
    "placeholder": "Faça uma pergunta…",
    "send": "Enviar",
    "errorNoConnection": "Sem conexão. Tente novamente.",
    "thanks": "Obrigado!"
  },
  "chatbotSettings": {
    "loading": "Carregando configurações do assistente…",
    "title": "🤖 Assistente de IA — Configurações",
    "subtitle": "Configure os tópicos, o tom e as preferências de idioma para este workspace.",
    "back": "Voltar às configurações do workspace",
    "saved": "Configurações salvas ✓",
    "saving": "Salvando…",
    "save": "Salvar mudanças",
    "reset": "Restaurar padrão",
    "resetConfirm": "Restaurar as configurações padrão do assistente para este workspace?",
    "resetDone": "Padrão restaurado ✓",
    "topicsTitle": "O que o assistente pode discutir?",
    "topicsDesc": "Desative tópicos que você não quer que o assistente responda neste workspace.",
    "topicVisa": "Visto & requisitos",
    "topicDocuments": "Documentos necessários",
    "topicTasks": "Tarefas & progresso",
    "topicBookings": "Reservas",
    "topicPacking": "Mala & packing",
    "topicResources": "Recursos & links",
    "topicGeneral": "Dicas gerais",
    "toneTitle": "Estilo de resposta",
    "toneDesc": "Como o assistente deve soar.",
    "toneFriendly": "Amigável",
    "toneFriendlyExample": "“Olá! Vamos organizar isso.”",
    "toneProfessional": "Profissional",
    "toneProfessionalExample": "“Posso ajudar com informações estruturadas sobre…”",
    "toneBrief": "Breve",
    "toneBriefExample": "“[Informação objetiva]”",
    "lengthTitle": "Extensão das respostas",
    "lengthDesc": "O nível de detalhe das respostas.",
    "lengthBrief": "Breve",
    "lengthBriefExample": "1–2 frases",
    "lengthMedium": "Médio",
    "lengthMediumExample": "2–3 parágrafos",
    "lengthDetailed": "Detalhado",
    "lengthDetailedExample": "Explicação completa",
    "sourcesTitle": "Fontes",
    "sourcesDesc": "Mostrar links oficiais quando possível.",
    "includeSources": "Citar fontes oficiais",
    "languagesTitle": "Idiomas",
    "languagesDesc": "Idiomas preferidos para respostas.",
    "langPt": "Português",
    "langEn": "Inglês",
    "langEs": "Espanhol",
    "actionsTitle": "Ações",
    "disclaimer": "O assistente sempre usa os dados do seu espaço. Nunca vai dar conselhos médicos ou legais específicos. Para questões legais, consulte um advogado."
  },
  "extraction": {
    "title": "Importar documento ou email",
    "via": "Via:",
    "textLabel": "Cole o texto do email ou documento",
    "textPlaceholder": "Cole o conteúdo do email, confirmação de reserva, documento de visto...",
    "or": "ou arraste um arquivo",
    "dropzoneHint": "Arraste PDF ou imagem aqui",
    "dropzoneClick": "ou clique para selecionar",
    "dropzoneTypes": "JPG, PNG, PDF (máx 10 MB)",
    "extract": "Extrair dados",
    "extracting": "Extraindo dados...",
    "cancel": "Cancelar",
    "close": "Fechar",
    "startOver": "Extrair outro",
    "confidence": "Confiança",
    "errorTitle": "Erro na extração",
    "saveAsBooking": "Salvar como reserva",
    "addToTimeline": "Adicionar à linha do tempo",
    "addToTasks": "Salvar como tarefa",
    "saveDocumentAndTask": "Salvar documento e criar tarefa",
    "saveAsDocument": "Salvar como documento",
    "importDocument": "Importar documento",
    "importTask": "Importar tarefa",
    "importTaskHint": "Cole um email, aviso, instrução ou qualquer texto com uma tarefa.",
    "taskDetected": "Tarefa detectada",
    "createTask": "Criar tarefa também",
    "taskTitle": "Título",
    "taskDescription": "Descrição",
    "taskDueDate": "Prazo",
    "taskCategory": "Categoria",
    "taskPriority": "Prioridade",
    "taskSection": "Seção",
    "saveTask": "Salvar tarefa",
    "discard": "Descartar",
    "taskSaved": "Tarefa criada!",
    "taskAndDocumentSaved": "Tarefa criada a partir deste documento. Você pode abri-la em Tarefas (incluindo a visão de linha do tempo) e o arquivo fica em Documentos.",
    "savedWorkSuccess": "Salvo no seu workspace.",
    "savedWorkHint": "Uma tarefa foi criada (e o arquivo fica em Documentos quando você enviou um). Abra Tarefas → Linha do tempo (Gantt) para ver prazos no cronograma.",
    "reviewConfirm": "Revisei os dados extraídos e estão corretos (ou ajustei o texto antes de salvar).",
    "lowConfidenceNote": "Confiança baixa. Confira todos os campos antes de salvar no workspace."
  },
  "header": {
    "features": "Funcionalidades",
    "pricing": "Preços",
    "guides": "Guias",
    "blog": "Blog",
    "faq": "FAQ",
    "contact": "Contato",
    "signIn": "Entrar",
    "signUp": "Criar conta",
    "startFree": "Começar grátis",
    "goToApp": "Ir para o app",
    "openMenu": "Abrir menu",
    "marketingNavLabel": "Navegação do site",
    "overview": "Visão geral",
    "allTrips": "Todas as viagens",
    "signOut": "Sair",
    "bookDemo": "Agendar demo"
  },
  "bookDemo": {
    "title": "Agende uma demonstração",
    "subtitle": "Veja o Wundrlst em ação. 30 minutos, sem compromisso.",
    "fieldFullName": "Nome completo",
    "fieldEmail": "E-mail",
    "fieldPhone": "Telefone / WhatsApp",
    "fieldDestination": "País de destino",
    "fieldVisaType": "Tipo de visto",
    "fieldMessage": "Mensagem / contexto",
    "submit": "Agendar demonstração",
    "success": "Recebemos sua solicitação! Entraremos em contato em até 24 horas.",
    "bullet1": "Organização completa de mudança internacional",
    "bullet2": "Extração automática de documentos e reservas",
    "bullet3": "Rotas de visto por passaporte e destino",
    "bulletsTitle": "O que você vai ver",
    "validation": "Informe nome e e-mail válidos.",
    "error": "Algo deu errado. Tente novamente.",
    "emailSubject": "Wundrlst — solicitação de demonstração",
    "messageFallback": "(Sem mensagem adicional.)"
  },
  "settings": {
    "title": "Configurações",
    "subtitle": "Preferências gerais, padrões da viagem, notificações, plano, conta e padrões de IA para novos workspaces. Idioma, moeda e tema ficam no menu da conta.",
    "breadcrumbRoot": "Configurações",
    "navLabel": "Seções de configurações",
    "nav": {
      "general": "Geral",
      "ai": "IA / Chatbot"
    },
    "page": {
      "general": {
        "title": "Configurações gerais",
        "lead": "Idioma, aparência, moeda padrão e preferências de viagem — tudo em um só lugar."
      },
      "ai": {
        "title": "IA e chatbot"
      }
    },
    "ai": {
      "description": "Essas opções de IA definem o comportamento padrão do assistente Wundrlst nos seus workspaces. Cada workspace ainda pode ter configurações próprias por enquanto.",
      "defaultsHeading": "Padrões para novos workspaces",
      "defaultsDescription": "Quando ativarmos padrões de IA na conta, novos workspaces começarão com estes valores. Hoje, apenas esta prévia fica salva no seu dispositivo durante a sessão.",
      "visaContextLabel": "Usar contexto de visto automaticamente nas respostas",
      "visaContextDesc": "Quando ativado, o assistente pode usar contexto de visto e imigração por padrão em novos workspaces (espelha o tópico “Visto e requisitos” por workspace).",
      "saveDefaults": "Salvar padrões",
      "stubSaved": "Salvo só nesta sessão — sincronização entre dispositivos virá depois."
    },
    "navTripDefaults": "Padrões da viagem",
    "navNotifications": "Notificações",
    "navPlan": "Plano e uso",
    "navAccount": "Conta e segurança",
    "tripDefaultsTitle": "Padrões da viagem",
    "tripDefaultsDescription": "O país de residência define sua moeda padrão para orçamentos e estimativas.",
    "tripDefaultsCurrencyHint": "A moeda padrão segue o país de residência. Você pode mudar a moeda quando quiser pelo menu da conta (barra lateral ou topo).",
    "toastTripDefaultsSaved": "Padrões da viagem salvos",
    "changePhoto": "Alterar foto",
    "fullName": "Nome completo",
    "email": "E-mail",
    "changeEmail": "Alterar e-mail",
    "emailReadonlyHint": "Use o fluxo de alteração para atualizar o endereço de login.",
    "countryResidence": "País de residência",
    "preferredCurrency": "Moeda padrão",
    "save": "Salvar",
    "cancel": "Cancelar",
    "sendLink": "Enviar confirmação",
    "toastProfileUpdated": "Perfil atualizado ✓",
    "avatarBucketNotConfigured": "O armazenamento de fotos não está pronto (bucket avatars ausente). Execute as migrações do Supabase neste projeto (ex.: supabase db push) ou crie o bucket “avatars” em Painel → Storage.",
    "avatarUploadFailed": "Não foi possível enviar a foto. Tente de novo.",
    "avatarTooLarge": "A imagem deve ter no máximo 2 MB.",
    "toastPhotoUpdated": "Foto de perfil atualizada",
    "changeEmailDesc": "Enviaremos uma confirmação para o novo endereço. Você precisa verificar para concluir.",
    "newEmail": "Novo e-mail",
    "emailChangeConfirm": "Verifique a caixa de entrada para confirmar o novo e-mail.",
    "language": "Idioma",
    "languageHint": "Altere o idioma pelo menu da conta.",
    "theme": "Tema",
    "themeLight": "Claro",
    "themeDark": "Escuro",
    "themeSystem": "Sistema",
    "dateFormat": "Formato de data",
    "dateFormatHint": "Usado ao escolher e exibir datas em tarefas, itinerários e formulários.",
    "generalAutoSaveHint": "As alterações aqui são salvas automaticamente. Ações destrutivas (sair, excluir conta) ficam em Conta e segurança.",
    "saving": "Salvando…",
    "timezone": "Fuso horário",
    "timezoneHint": "Usado para lembretes, prazos e resumos no seu horário local.",
    "timezoneAuto": "Automático (dispositivo)",
    "timezoneSearchPlaceholder": "Buscar fusos…",
    "generalLanguageHelper": "Idioma da interface. Salvo no seu perfil.",
    "generalThemeHelper": "Claro, escuro ou seguir o dispositivo. Salvo no seu perfil.",
    "generalCurrencyHelper": "Padrão para valores e orçamentos quando não houver outro contexto.",
    "toastPreferencesSaved": "Preferências de exibição salvas",
    "notificationsTitle": "Notificações",
    "notificationsEmailPhase2": "E-mail virá em uma fase futura. Suas opções são salvas agora; o painel de urgência da visão geral usa sinais no app.",
    "notifWeeklyDigest": "Resumo semanal de progresso",
    "notifOverdueTasks": "Tarefas com prazo vencido",
    "notifPendingDocuments": "Documentos pendentes",
    "notifItineraryReminders": "Lembretes de eventos no itinerário",
    "notifAppointmentReminders": "Lembretes de compromissos (vistos, consulados)",
    "notifHowFarAhead": "Com quanto tempo de antecedência?",
    "notifAdvance1d": "1 dia",
    "notifAdvance3d": "3 dias",
    "notifAdvance7d": "7 dias",
    "toastNotificationsSaved": "Preferências de notificação salvas",
    "planTitle": "Plano e uso",
    "planDescription": "Seu plano atual, limites de workspaces e o que cada nível inclui.",
    "planCurrent": "Plano atual",
    "planNameFree": "Gratuito",
    "planNamePro": "Pro",
    "planNameBusiness": "Business",
    "planUsage": "Workspaces",
    "planUsageValue": "{{used}} / {{limit}} workspaces usados",
    "planUnlimitedWorkspaces": "Workspaces ilimitados no seu plano.",
    "planNextBillingPlaceholder": "Próxima cobrança: disponível quando a assinatura for integrada (Stripe).",
    "planFeatureFree1": "2 workspaces, 50 tarefas por workspace, 3 extrações",
    "planFeatureFree2": "",
    "planFeatureFree3": "",
    "planFeaturePro1": "Workspaces ilimitados",
    "planFeaturePro2": "Recursos avançados, lembretes por e-mail",
    "planFeaturePro3": "Mais automação conforme lançarmos",
    "planFeatureBiz1": "Colaboração em equipe",
    "planFeatureBiz2": "Suporte prioritário",
    "planUpgradeCta": "Fazer upgrade para Pro",
    "planManageSubscription": "Gerenciar assinatura",
    "planContactSales": "Falar com vendas",
    "accountTitle": "Conta e segurança",
    "accountDescription": "Foto, nome, e-mail, senha e sessão.",
    "accountChangePassword": "Alterar senha",
    "accountChangePasswordDesc": "Confirme a senha atual e defina uma nova (mín. 8 caracteres).",
    "accountExportData": "Exportar meus dados",
    "accountExportDataDesc": "Baixe um JSON com o perfil e os dados dos workspaces.",
    "accountSignOutDesc": "Encerre a sessão neste dispositivo.",
    "accountDelete": "Excluir conta",
    "accountDeleteDesc": "Remove permanentemente a conta e todos os dados associados.",
    "accountNotSignedIn": "Você precisa estar autenticado.",
    "passwordMin8": "A nova senha deve ter pelo menos 8 caracteres.",
    "passwordMustDiffer": "A nova senha deve ser diferente da atual.",
    "passwordMismatch": "Nova senha e confirmação não coincidem.",
    "currentPasswordWrong": "Senha atual incorreta.",
    "passwordChanged": "Senha atualizada",
    "currentPassword": "Senha atual",
    "newPassword": "Nova senha",
    "confirmPassword": "Confirmar nova senha",
    "savePassword": "Atualizar senha",
    "exportSuccess": "Exportação iniciada — veja os downloads",
    "exportFailed": "Não foi possível exportar os dados",
    "deleteTypeInvalid": "Digite a palavra de confirmação exatamente.",
    "deleteWarning": "Esta ação não pode ser desfeita. Todos os seus dados serão removidos, incluindo viagens e perfil.",
    "deleteTypeInstruction": "Digite {{code}} para confirmar.",
    "deleteConfirm": "Excluir para sempre",
    "deleteFailed": "Falha ao excluir a conta",
    "planExtractionUsage": "Extrações de documentos: {{used}} / {{limit}} (plano gratuito)"
  },
  "usage": {
    "sidebarWorkspaces": "{{used}}/{{max}} espaços usados"
  },
  "upgrade": {
    "title": "Upgrade para Wundrlst Pro",
    "subtitle": "Você atingiu o limite do plano gratuito.",
    "proIncludes": "Com o Pro você tem:",
    "bulletWorkspaces": "Workspaces ilimitados",
    "bulletTasks": "Tarefas ilimitadas",
    "bulletExtraction": "Extração ilimitada de documentos",
    "bulletEmail": "Lembretes por e-mail",
    "bulletSupport": "Suporte prioritário",
    "price": "Preço: US$ 19/mês",
    "viewPlans": "Ver planos",
    "notNow": "Agora não",
    "featureWorkspace": "Você usou todos os workspaces gratuitos. Faça upgrade para criar mais.",
    "featureTasks": "Você atingiu o limite de 50 tarefas. Upgrade para Pro para tarefas ilimitadas.",
    "featureExtraction": "Você usou todas as extrações gratuitas. Faça upgrade para extração ilimitada.",
    "loginRequiredExtraction": "Entre na conta para extrair documentos."
  },
  "marketing": {
    "contact": {
      "pageTitle": "Fale conosco",
      "pageSubtitle": "Lemos toda mensagem. Compartilhe o contexto e indicamos o melhor próximo passo no Wundrlst.",
      "infoTitle": "Outras formas de contato",
      "infoProduct": "Produto e feedback",
      "infoPress": "Imprensa",
      "infoRemote": "Time remoto",
      "infoRemoteBody": "Sem escritório. Atuamos em vários fusos — São Paulo · Lisboa · onde a mudança acontecer.",
      "title": "Envie uma mensagem",
      "name": "Nome completo",
      "email": "E-mail profissional",
      "subject": "Assunto",
      "message": "Mensagem",
      "namePlaceholder": "Ana Silva",
      "emailPlaceholder": "ana@exemplo.com",
      "subjectPlaceholder": "Bug, ideia de recurso ou dúvida",
      "messagePlaceholder": "Destino, prazo, o que você já tentou…",
      "send": "Enviar mensagem",
      "sending": "Enviando…",
      "successTitle": "Mensagem enviada!",
      "successBody": "Retornamos em breve.",
      "successToast": "Mensagem enviada! Retornamos em breve.",
      "error": "Não foi possível enviar. Tente novamente.",
      "validation": "Preencha todos os campos com um e-mail válido."
    },
    "waitlist": {
      "eyebrow": "Acesso antecipado",
      "title": "Entre na lista de espera do Wundrlst",
      "subtitle": "Seja o primeiro a saber quando abrirmos novas vagas de beta.",
      "email": "E-mail",
      "nameOptional": "Nome (opcional)",
      "placeholderName": "Seu nome",
      "submit": "Entrar na lista",
      "success": "🎉 Você está na lista de espera!",
      "toastNew": "Inscrição recebida — em breve entramos em contato.",
      "duplicate": "Você já está na lista!",
      "error": "Não foi possível inscrever. Tente novamente.",
      "invalidEmail": "Digite um e-mail válido."
    }
  },
  "visaExplorer": {
    "pageTitle": "Consulta de vistos",
    "pageSubtitle": "Escolha nacionalidade e destino para ver requisitos de visto com dados atualizados.",
    "dashboardTitle": "Consulta de vistos",
    "dashboardSubtitle": "Consulte os tipos de visto e abra um workspace quando quiser organizar a viagem.",
    "imFrom": "Nacionalidade",
    "imFromHint": "País emissor do seu passaporte (código ISO de 2 letras, por exemplo MZ ou BR)",
    "goingTo": "Destino",
    "goingToHint": "País ou território para onde você vai viajar",
    "pickNationality": "Pesquisar país…",
    "pickDestination": "Pesquisar país…",
    "checkCta": "Consultar requisitos de visto",
    "checkCtaShort": "Consultar",
    "loading": "Verificando…",
    "fetchErrorFallback": "Não foi possível carregar os dados de visto. Tente novamente.",
    "emptyStateTitle": "Ainda não há dados de visto para esta rota",
    "emptyState": "Não temos informações para essa combinação ainda. Tente outra rota ou volte em breve.",
    "visaFreeBanner": "Boa notícia — você não precisa de visto para esta viagem",
    "voaBanner": "Visto na chegada — não é o mesmo que isenção de visto",
    "voaBannerBody": "Você ainda precisa obter um visto na fronteira ou no aeroporto. Podem haver taxas, documentos e critérios. Confirme com a autoridade do destino antes de viajar.",
    "trustVerifiedHint": "Com base em dados de rota verificados por humanos no Wundrlst. Confirme sempre com a autoridade oficial antes de viajar.",
    "tipRelax": "Confira as regras de entrada com a autoridade do destino antes de viajar.",
    "entryType": "Tipo de entrada",
    "entryTypeVisaFree": "Dispensa de visto",
    "entryTypeVisaOnArrival": "Visto na chegada",
    "entryTypeEVisa": "E-visto",
    "entryTypeVisaRequired": "Visto obrigatório antes da viagem",
    "detailsCta": "Detalhes",
    "costUsd": "US$ {{amount}} (estimado)",
    "costUsdEstimated": "US$ {{amount}} (estimado)",
    "costUnknown": "Desconhecido — não confirmado",
    "durationDays": "Até {{days}} dias",
    "durationVaries": "Duração varia",
    "durationLabel": "Duração",
    "costLabel": "Custo",
    "complexityLabel": "Complexidade",
    "processingTimeLabel": "Prazo de processamento",
    "complexity": {
      "low": "Baixa",
      "medium": "Média",
      "high": "Alta"
    },
    "prEligibleShort": "Residência permanente",
    "citizenshipEligibleShort": "Cidadania",
    "yesMark": "✓",
    "noMark": "✗",
    "unknownMark": "—",
    "tabOverview": "Visão geral",
    "tabRequirements": "Requisitos",
    "tabDocuments": "Documentos",
    "aboutFallback": "Regras oficiais podem mudar — confirme sempre com a autoridade do destino.",
    "noRequirementsListed": "Ainda não há requisitos listados para esta rota.",
    "noDocumentsListed": "Ainda não há lista de documentos para esta rota.",
    "ctaSignup": "Comece a planejar esta viagem →",
    "ctaCreateWorkspace": "Criar workspace para esta viagem",
    "ctaProvisioning": "Criando workspace…",
    "matchLookupLoading": "Verificando suas viagens…",
    "hasWorkspace": "Você já tem um workspace para esta viagem",
    "ctaOpenWorkspace": "Abrir workspace",
    "ctaCreateAnother": "Criar outro",
    "intentBanner": "Salvamos a rota: {{from}} → {{to}}. Você pode alterar abaixo."
  }
}
